// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Luna Point 2
 * Service Luna Point 2
 * Version: v.0.0.0
 */import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  MutationFunctionContext,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Attribute,
  AttributeBinary,
  AttributeSamples,
  AuthorizationErrorResponse,
  AuthorizationErrorWithoutBodyResponse,
  Card,
  CardId,
  CardNotFoundResponse,
  CardToBeCreated,
  CardToBeUpdated,
  CardsCount,
  CardsToBeDeleted,
  CheckFaceParams,
  CheckImageParams,
  CreateCardResponse,
  CreateDepartmentRequest,
  CreateFace201,
  CreateGroupRequest,
  CreateGroupResponse,
  CreateHandlerRequest,
  CreateListRequest,
  CreatePermissionTagRequest,
  CreateRoleRequest,
  CreateStreamParams,
  CreateStreamRequest,
  CreateStreamResponse,
  CreatedDepartment,
  CreatedHandler,
  CreatedList,
  CreatedPermissionTag,
  CreatedRole,
  CreatedUser,
  DeleteCardsParams,
  DeleteDepartmentsParams,
  DeleteDepartmentsRequest,
  DeleteFacesParams,
  DeleteListsRequest,
  DeletePermissionTagsParams,
  DeleteRolesParams,
  DeleteStreamsRequest,
  DepartmentNotFoundResponse,
  DepartmentRecord,
  DepartmentsList,
  Error,
  EstimateSdkParams,
  EventNotFoundResponse,
  EventRecord,
  EventStatisticRequest,
  EventStatisticResponse,
  EventsList,
  FaceNotFoundErrorResponse,
  FaceToBeCreated,
  FaceToBeCreatedBinary,
  FaceToBeUpdated,
  FacesToBeDeleted,
  FeaturesResponse,
  ForbiddenErrorWithoutBodyResponse,
  ForbiddenFacesErrorResponse,
  GenerateHandlerEvents201,
  GenerateHandlerEventsBodyOnenine,
  GenerateHandlerEventsParams,
  GetCardParams,
  GetCards200,
  GetCardsCountParams,
  GetCardsParams,
  GetConfig200One,
  GetDepartmentsParams,
  GetEventParams,
  GetEventsParams,
  GetFaceAttributesParams,
  GetFaceParams,
  GetFaces200,
  GetFacesParams,
  GetGroupsCountParams,
  GetGroupsParams,
  GetHandlersCountParams,
  GetHandlersParams,
  GetImageParams,
  GetListsCountParams,
  GetListsParams,
  GetPermissionTagsCountParams,
  GetPermissionTagsParams,
  GetRolesCountParams,
  GetRolesParams,
  GetStreamParams,
  GetStreamRestreamParams,
  GetStreamsCountParams,
  GetStreamsLogsParams,
  GetStreamsParams,
  GetUsersCountParams,
  GetUsersParams,
  GroupNotFoundResponse,
  GroupRecord,
  GroupsCount,
  GroupsList,
  HandlerNotFoundResponse,
  HandlerRecord,
  HandlersCount,
  HandlersList,
  Healthcheck200,
  Healthcheck502,
  HealthcheckParams,
  ImageNotFoundResponse,
  InternalServerErrorResponse,
  InternalServerErrorWithoutBodyResponse,
  ListNotFoundResponse,
  ListRecord,
  ListsCount,
  ListsList,
  MatchBodiesRequest,
  MatchBodiesResponse,
  MatchFacesRequest,
  MatchFacesResponse,
  MatchRawRequest,
  MatchRawResponse,
  MultipartSdkImageSchema,
  OutputFace,
  OutputFaceAttributeJson,
  OutputFaceAttributeMsgpack,
  PasswordResetConfirmRequest,
  PasswordResetLink,
  PatchDepartmentRequest,
  PatchGroupStreamsParams,
  PatchGroupStreamsResponse,
  PatchRoleParams,
  PatchRoleRequest,
  PatchStreamRequest,
  PatchStreamResponse,
  PayloadToLargeResponse,
  PermissionErrorResponse,
  PermissionTagsCount,
  PermissionTagsList,
  PermissionTagsToBeDeleted,
  Plugins,
  PutGroupParams,
  PutGroupRequest,
  PutGroupResponse,
  RequestTimeoutResponse,
  RequestTimeoutWithoutBodyResponse,
  ResponseTimeoutResponse,
  ResponseTimeoutWithoutBodyResponse,
  RoleNotFoundResponse,
  RoleRecord,
  RolesCount,
  RolesList,
  RolesToBeDeleted,
  SampleCreated,
  SampleNotFoundResponse,
  SaveSampleParams,
  SdkJsonRequestBody,
  SdkResponseJson,
  SdkResponseMsgpack,
  ServerTimeoutErrorResponse,
  ServerTimeoutErrorWithoutBodyResponse,
  StreamRecord,
  StreamRestreamResponse,
  StreamsCount,
  StreamsList,
  StreamsLogs,
  SystemUserToBeCreated,
  TransferGroupStreamsRequest,
  TransferGroupStreamsResponse,
  UpdateGroupRequest,
  UpdateLinker207,
  UpdateLinkerBody,
  UpdateListRequest,
  UpdateStreamResponse,
  UserRecord,
  UserToBeCreated,
  UserToBeUpdated,
  UsersCount,
  UsersList,
  Uuid,
  Version
} from './model';

import { point2AxiosClient } from '../axios/point2-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * get service version
 * @summary get version
 */
export const getVersion = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<Version>(
      {url: `/version`, method: 'GET', signal
    },
      options);
    }




export const getGetVersionQueryKey = () => {
    return [
    `/version`
    ] as const;
    }


export const getGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({ signal }) => getVersion(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getVersion>>>
export type GetVersionQueryError = InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get version
 */

export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary version options
 */
export const getVersionOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/version`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetVersionOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVersionOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getVersionOptions>>, TError,void, TContext> => {

const mutationKey = ['getVersionOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getVersionOptions>>, void> = () => {


          return  getVersionOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetVersionOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getVersionOptions>>>

    export type GetVersionOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary version options
 */
export const useGetVersionOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getVersionOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getVersionOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetVersionOptionsMutationOptions(options), queryClient);
    }

/**
 * Get service OpenApi documentation. If *Accept* request header is of type `application/x-yaml`,
 * returns documentation in `yaml` format or returns `html` documentation, if *Accept-Type* is `text/html`
 * @summary get openapi documentation
 */
export const getSpec = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<string>(
      {url: `/1/docs/spec`, method: 'GET', signal
    },
      options);
    }




export const getGetSpecQueryKey = () => {
    return [
    `/1/docs/spec`
    ] as const;
    }


export const getGetSpecQueryOptions = <TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpecQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpec>>> = ({ signal }) => getSpec(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpecQueryResult = NonNullable<Awaited<ReturnType<typeof getSpec>>>
export type GetSpecQueryError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpec>>,
          TError,
          Awaited<ReturnType<typeof getSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpec>>,
          TError,
          Awaited<ReturnType<typeof getSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get openapi documentation
 */

export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSpecQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary get openapi documentation options
 */
export const getSpecOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/docs/spec`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSpecOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSpecOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSpecOptions>>, TError,void, TContext> => {

const mutationKey = ['getSpecOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSpecOptions>>, void> = () => {


          return  getSpecOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSpecOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSpecOptions>>>

    export type GetSpecOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary get openapi documentation options
 */
export const useGetSpecOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSpecOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSpecOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetSpecOptionsMutationOptions(options), queryClient);
    }

/**
 * Get sphinx documentation - *Development Manual*. After the request you will be redirected to the page `/docs/dev/index.html`
 * @summary get development manual
 */
export const getDevManual = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<string>(
      {url: `/1/docs/dev`, method: 'GET', signal
    },
      options);
    }




export const getGetDevManualQueryKey = () => {
    return [
    `/1/docs/dev`
    ] as const;
    }


export const getGetDevManualQueryOptions = <TData = Awaited<ReturnType<typeof getDevManual>>, TError = InternalServerErrorResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDevManualQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDevManual>>> = ({ signal }) => getDevManual(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDevManualQueryResult = NonNullable<Awaited<ReturnType<typeof getDevManual>>>
export type GetDevManualQueryError = InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevManual>>,
          TError,
          Awaited<ReturnType<typeof getDevManual>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDevManual>>,
          TError,
          Awaited<ReturnType<typeof getDevManual>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get development manual
 */

export function useGetDevManual<TData = Awaited<ReturnType<typeof getDevManual>>, TError = InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDevManual>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDevManualQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary get development manual options
 */
export const getDevManualOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/docs/dev`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetDevManualOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDevManualOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getDevManualOptions>>, TError,void, TContext> => {

const mutationKey = ['getDevManualOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getDevManualOptions>>, void> = () => {


          return  getDevManualOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetDevManualOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getDevManualOptions>>>

    export type GetDevManualOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary get development manual options
 */
export const useGetDevManualOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDevManualOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getDevManualOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetDevManualOptionsMutationOptions(options), queryClient);
    }

/**
 * Get service configuration. Passwords and tokens will be hidden in the response.
 * @summary get service configuration
 */
export const getConfig = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<GetConfig200One | string>(
      {url: `/1/config`, method: 'GET', signal
    },
      options);
    }




export const getGetConfigQueryKey = () => {
    return [
    `/1/config`
    ] as const;
    }


export const getGetConfigQueryOptions = <TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfig>>> = ({ signal }) => getConfig(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getConfig>>>
export type GetConfigQueryError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get service configuration
 */

export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary get config options
 */
export const getConfigOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/config`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetConfigOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getConfigOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getConfigOptions>>, TError,void, TContext> => {

const mutationKey = ['getConfigOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getConfigOptions>>, void> = () => {


          return  getConfigOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetConfigOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getConfigOptions>>>

    export type GetConfigOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary get config options
 */
export const useGetConfigOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getConfigOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getConfigOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetConfigOptionsMutationOptions(options), queryClient);
    }

/**
 * Get list of service plugins:
 * @summary get list of plugins
 */
export const getPlugins = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<Plugins>(
      {url: `/1/plugins`, method: 'GET', signal
    },
      options);
    }




export const getGetPluginsQueryKey = () => {
    return [
    `/1/plugins`
    ] as const;
    }


export const getGetPluginsQueryOptions = <TData = Awaited<ReturnType<typeof getPlugins>>, TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlugins>>> = ({ signal }) => getPlugins(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPluginsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlugins>>>
export type GetPluginsQueryError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlugins>>,
          TError,
          Awaited<ReturnType<typeof getPlugins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlugins>>,
          TError,
          Awaited<ReturnType<typeof getPlugins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get list of plugins
 */

export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPluginsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary plugins options
 */
export const getPluginsOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/plugins`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetPluginsOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPluginsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getPluginsOptions>>, TError,void, TContext> => {

const mutationKey = ['getPluginsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPluginsOptions>>, void> = () => {


          return  getPluginsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPluginsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getPluginsOptions>>>

    export type GetPluginsOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary plugins options
 */
export const useGetPluginsOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPluginsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPluginsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetPluginsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get statistics of success and failed requests to the service in prometheus format.
 * @summary get service requests statistics
 */
export const metrics = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<string>(
      {url: `/metrics`, method: 'GET', signal
    },
      options);
    }




export const getMetricsQueryKey = () => {
    return [
    `/metrics`
    ] as const;
    }


export const getMetricsQueryOptions = <TData = Awaited<ReturnType<typeof metrics>>, TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof metrics>>> = ({ signal }) => metrics(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MetricsQueryResult = NonNullable<Awaited<ReturnType<typeof metrics>>>
export type MetricsQueryError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metrics>>,
          TError,
          Awaited<ReturnType<typeof metrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metrics>>,
          TError,
          Awaited<ReturnType<typeof metrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get service requests statistics
 */

export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMetricsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary get metrics options
 */
export const metricsOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/metrics`, method: 'OPTIONS', signal
    },
      options);
    }




export const getMetricsOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metricsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof metricsOptions>>, TError,void, TContext> => {

const mutationKey = ['metricsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof metricsOptions>>, void> = () => {


          return  metricsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MetricsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof metricsOptions>>>

    export type MetricsOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary get metrics options
 */
export const useMetricsOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metricsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof metricsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMetricsOptionsMutationOptions(options), queryClient);
    }

/**
 * get health of service
 * @summary get health
 */
export const healthcheck = (
    params?: HealthcheckParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<Healthcheck200>(
      {url: `/healthcheck`, method: 'GET',
        params, signal
    },
      options);
    }




export const getHealthcheckQueryKey = (params?: HealthcheckParams,) => {
    return [
    `/healthcheck`, ...(params ? [params] : [])
    ] as const;
    }


export const getHealthcheckQueryOptions = <TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | Healthcheck502 | ServerTimeoutErrorResponse>(params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthcheckQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthcheck>>> = ({ signal }) => healthcheck(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthcheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthcheck>>>
export type HealthcheckQueryError = InternalServerErrorResponse | Healthcheck502 | ServerTimeoutErrorResponse


export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | Healthcheck502 | ServerTimeoutErrorResponse>(
 params: undefined |  HealthcheckParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheck>>,
          TError,
          Awaited<ReturnType<typeof healthcheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | Healthcheck502 | ServerTimeoutErrorResponse>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheck>>,
          TError,
          Awaited<ReturnType<typeof healthcheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | Healthcheck502 | ServerTimeoutErrorResponse>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get health
 */

export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | Healthcheck502 | ServerTimeoutErrorResponse>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthcheckQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary get health options
 */
export const healthcheckOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/healthcheck`, method: 'OPTIONS', signal
    },
      options);
    }




export const getHealthcheckOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof healthcheckOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof healthcheckOptions>>, TError,void, TContext> => {

const mutationKey = ['healthcheckOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof healthcheckOptions>>, void> = () => {


          return  healthcheckOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HealthcheckOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof healthcheckOptions>>>

    export type HealthcheckOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary get health options
 */
export const useHealthcheckOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof healthcheckOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof healthcheckOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getHealthcheckOptionsMutationOptions(options), queryClient);
    }

/**
 * Set login cookie.
 * @summary set login cookie
 */
export const setLoginCookie = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/login`, method: 'POST', signal
    },
      options);
    }




export const getSetLoginCookieMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLoginCookie>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof setLoginCookie>>, TError,void, TContext> => {

const mutationKey = ['setLoginCookie'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLoginCookie>>, void> = () => {


          return  setLoginCookie(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetLoginCookieMutationResult = NonNullable<Awaited<ReturnType<typeof setLoginCookie>>>

    export type SetLoginCookieMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary set login cookie
 */
export const useSetLoginCookie = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLoginCookie>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLoginCookie>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSetLoginCookieMutationOptions(options), queryClient);
    }

/**
 * Clear login cookie.
 * @summary clear login cookie
 */
export const deleteLoginCookie = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/login`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteLoginCookieMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLoginCookie>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLoginCookie>>, TError,void, TContext> => {

const mutationKey = ['deleteLoginCookie'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLoginCookie>>, void> = () => {


          return  deleteLoginCookie(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLoginCookieMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLoginCookie>>>

    export type DeleteLoginCookieMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary clear login cookie
 */
export const useDeleteLoginCookie = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLoginCookie>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLoginCookie>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteLoginCookieMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary login cookie options
 */
export const getLoginCookieOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/login`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetLoginCookieOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLoginCookieOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getLoginCookieOptions>>, TError,void, TContext> => {

const mutationKey = ['getLoginCookieOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getLoginCookieOptions>>, void> = () => {


          return  getLoginCookieOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetLoginCookieOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getLoginCookieOptions>>>

    export type GetLoginCookieOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary login cookie options
 */
export const useGetLoginCookieOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getLoginCookieOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getLoginCookieOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetLoginCookieOptionsMutationOptions(options), queryClient);
    }

/**
 * Register a new system user. Requires administrator Basic auth credentials.
 * @summary create system user
 */
export const createSystemUser = (
    systemUserToBeCreated: SystemUserToBeCreated,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreatedUser>(
      {url: `/1/admins/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: systemUserToBeCreated, signal
    },
      options);
    }




export const getCreateSystemUserMutationOptions = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSystemUser>>, TError,{data: SystemUserToBeCreated}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createSystemUser>>, TError,{data: SystemUserToBeCreated}, TContext> => {

const mutationKey = ['createSystemUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSystemUser>>, {data: SystemUserToBeCreated}> = (props) => {
          const {data} = props ?? {};

          return  createSystemUser(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateSystemUserMutationResult = NonNullable<Awaited<ReturnType<typeof createSystemUser>>>
    export type CreateSystemUserMutationBody = SystemUserToBeCreated
    export type CreateSystemUserMutationError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary create system user
 */
export const useCreateSystemUser = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSystemUser>>, TError,{data: SystemUserToBeCreated}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSystemUser>>,
        TError,
        {data: SystemUserToBeCreated},
        TContext
      > => {
      return useMutation(getCreateSystemUserMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary admins users options
 */
export const getAdminUsersOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/admins/users`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetAdminUsersOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAdminUsersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getAdminUsersOptions>>, TError,void, TContext> => {

const mutationKey = ['getAdminUsersOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAdminUsersOptions>>, void> = () => {


          return  getAdminUsersOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetAdminUsersOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getAdminUsersOptions>>>

    export type GetAdminUsersOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary admins users options
 */
export const useGetAdminUsersOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAdminUsersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAdminUsersOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetAdminUsersOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a new user within the authenticated user's domain
 * (``lp_account_id``).
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * * ``"global"`` — ``role_id`` can reference any role in the domain;
 *   ``department_ids`` can reference any departments.
 * * ``"local"`` — ``role_id`` can only reference roles whose
 *   ``permissions.visibility`` is ``"local"`` or ``"basic"``;
 *   ``department_ids`` must belong to the requesting user.
 * * ``"basic"`` — ``role_id`` can only reference roles whose
 *   ``permissions.visibility`` is ``"basic"``; ``department_ids``
 *   must belong to the requesting user.
 * @summary create user
 */
export const createUser = (
    userToBeCreated: UserToBeCreated,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreatedUser>(
      {url: `/1/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userToBeCreated, signal
    },
      options);
    }




export const getCreateUserMutationOptions = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: UserToBeCreated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: UserToBeCreated}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: UserToBeCreated}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createUser>>, variables: {data: UserToBeCreated}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetUsersQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = UserToBeCreated
    export type CreateUserMutationError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary create user
 */
export const useCreateUser = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: UserToBeCreated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: UserToBeCreated},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateUserMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get list of all users.
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * * ``"global"`` — all records matching filters (requires
 *   ``users=read``).
 * * ``"local"`` — records of users sharing at least one department
 *   with the authenticated user.
 * * ``"basic"`` — only the authenticated user's own record.
 *
 * A user without ``users=read`` always sees only their own record,
 * regardless of visibility level.
 * @summary get users
 */
export const getUsers = (
    params?: GetUsersParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<UsersList>(
      {url: `/1/users`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUsersInfiniteQueryKey = (params?: GetUsersParams,) => {
    return [
    'infinite', `/1/users`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetUsersQueryKey = (params?: GetUsersParams,) => {
    return [
    `/1/users`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUsersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getUsers>>, GetUsersParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData, QueryKey, GetUsersParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>, QueryKey, GetUsersParams['page']> = ({ signal, pageParam }) => getUsers({...params, 'page': pageParam ?? params?.['page']}, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData, QueryKey, GetUsersParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type GetUsersInfiniteQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUsers>>, GetUsersParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetUsersParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData, QueryKey, GetUsersParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUsers>>, GetUsersParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData, QueryKey, GetUsersParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUsers>>, GetUsersParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData, QueryKey, GetUsersParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get users
 */

export function useGetUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getUsers>>, GetUsersParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData, QueryKey, GetUsersParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUsersQueryOptions = <TData = Awaited<ReturnType<typeof getUsers>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) => getUsers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type GetUsersQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get users
 */

export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary users options
 */
export const getUsersOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/users`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetUsersOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getUsersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getUsersOptions>>, TError,void, TContext> => {

const mutationKey = ['getUsersOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getUsersOptions>>, void> = () => {


          return  getUsersOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetUsersOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getUsersOptions>>>

    export type GetUsersOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary users options
 */
export const useGetUsersOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getUsersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getUsersOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetUsersOptionsMutationOptions(options), queryClient);
    }

/**
 * Get users count according to filters.
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * * ``"global"`` - counts all records matching the filters (requires
 *   ``users=read``).
 * * ``"local"`` - counts users sharing at least one department with the
 *   authenticated user.
 * * ``"basic"`` - counts only the authenticated user's own record.
 *
 * A user without ``users=read`` always counts only their own record,
 * regardless of visibility level. If the user's own record does not
 * match the specified filters, the returned count is ``0``.
 *
 * Sorting and pagination are not used for this method because the method
 * returns aggregated users count only.
 * @summary get users count
 */
export const getUsersCount = (
    params?: GetUsersCountParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<UsersCount>(
      {url: `/1/users/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetUsersCountQueryKey = (params?: GetUsersCountParams,) => {
    return [
    `/1/users/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUsersCountQueryOptions = <TData = Awaited<ReturnType<typeof getUsersCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetUsersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersCount>>> = ({ signal }) => getUsersCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersCount>>>
export type GetUsersCountQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetUsersCount<TData = Awaited<ReturnType<typeof getUsersCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetUsersCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersCount>>,
          TError,
          Awaited<ReturnType<typeof getUsersCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersCount<TData = Awaited<ReturnType<typeof getUsersCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetUsersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersCount>>,
          TError,
          Awaited<ReturnType<typeof getUsersCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersCount<TData = Awaited<ReturnType<typeof getUsersCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetUsersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get users count
 */

export function useGetUsersCount<TData = Awaited<ReturnType<typeof getUsersCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetUsersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get the authenticated user's own record.
 *
 * The user always has access to their own record regardless of whether
 * they hold the ``Roles.permissions.users = "read"`` permission.
 * @summary get self
 */
export const getSelf = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<UserRecord>(
      {url: `/1/users/self`, method: 'GET', signal
    },
      options);
    }




export const getGetSelfQueryKey = () => {
    return [
    `/1/users/self`
    ] as const;
    }


export const getGetSelfQueryOptions = <TData = Awaited<ReturnType<typeof getSelf>>, TError = AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSelfQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSelf>>> = ({ signal }) => getSelf(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSelfQueryResult = NonNullable<Awaited<ReturnType<typeof getSelf>>>
export type GetSelfQueryError = AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetSelf<TData = Awaited<ReturnType<typeof getSelf>>, TError = AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSelf>>,
          TError,
          Awaited<ReturnType<typeof getSelf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSelf<TData = Awaited<ReturnType<typeof getSelf>>, TError = AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSelf>>,
          TError,
          Awaited<ReturnType<typeof getSelf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSelf<TData = Awaited<ReturnType<typeof getSelf>>, TError = AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get self
 */

export function useGetSelf<TData = Awaited<ReturnType<typeof getSelf>>, TError = AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSelf>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSelfQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary users self options
 */
export const getSelfOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/users/self`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSelfOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSelfOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSelfOptions>>, TError,void, TContext> => {

const mutationKey = ['getSelfOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSelfOptions>>, void> = () => {


          return  getSelfOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSelfOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSelfOptions>>>

    export type GetSelfOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary users self options
 */
export const useGetSelfOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSelfOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSelfOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetSelfOptionsMutationOptions(options), queryClient);
    }

/**
 * Get user by ID.
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * * ``"global"`` — any user in the domain (requires ``users=read``).
 * * ``"local"`` — only users sharing at least one department with
 *   the authenticated user.
 * * ``"basic"`` — only the authenticated user's own record.
 *
 * A user can always read their own record, even without
 * ``users=read`` permission.
 * @summary get user
 */
export const getUser = (
    userId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<UserRecord>(
      {url: `/1/users/${userId}`, method: 'GET', signal
    },
      options);
    }




export const getGetUserQueryKey = (userId: string,) => {
    return [
    `/1/users/${userId}`
    ] as const;
    }


export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = AuthorizationErrorResponse | Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = AuthorizationErrorResponse | Error | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = AuthorizationErrorResponse | Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = AuthorizationErrorResponse | Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = AuthorizationErrorResponse | Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get user
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = AuthorizationErrorResponse | Error | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update user by ID.
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * For the ``/{user_id}`` path parameter:
 *
 * * ``"global"`` — any user in the domain.
 * * ``"local"`` — only users sharing at least one department.
 * * ``"basic"`` — only the authenticated user's own record.
 *
 * For ``role_id``:
 *
 * * ``"global"`` — any role in the domain.
 * * ``"local"`` — only roles with ``visibility`` in
 *   ``("local", "basic")``.
 * * ``"basic"`` — only roles with ``visibility == "basic"``.
 *
 * For ``department_ids``:
 *
 * * ``"global"`` — any departments in the domain.
 * * ``"local"`` / ``"basic"`` — only departments the user belongs to.
 *
 * If the new role grants effective permissions different from the current ones, they are
 * synchronized and a 204 response is returned.
 * @summary patch user
 */
export const patchUser = (
    userId: string,
    userToBeUpdated: UserToBeUpdated,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/users/${userId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userToBeUpdated, signal
    },
      options);
    }




export const getPatchUserMutationOptions = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUser>>, TError,{userId: string;data: UserToBeUpdated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchUser>>, TError,{userId: string;data: UserToBeUpdated}, TContext> => {

const mutationKey = ['patchUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUser>>, {userId: string;data: UserToBeUpdated}> = (props) => {
          const {userId,data} = props ?? {};

          return  patchUser(userId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof patchUser>>, variables: {userId: string;data: UserToBeUpdated}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetUsersQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetUserQueryKey(variables.userId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PatchUserMutationResult = NonNullable<Awaited<ReturnType<typeof patchUser>>>
    export type PatchUserMutationBody = UserToBeUpdated
    export type PatchUserMutationError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary patch user
 */
export const usePatchUser = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUser>>, TError,{userId: string;data: UserToBeUpdated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchUser>>,
        TError,
        {userId: string;data: UserToBeUpdated},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPatchUserMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary user options
 */
export const getUserOptions = (
    userId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/users/${userId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetUserOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getUserOptions>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getUserOptions>>, TError,{userId: string}, TContext> => {

const mutationKey = ['getUserOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getUserOptions>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  getUserOptions(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetUserOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getUserOptions>>>

    export type GetUserOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary user options
 */
export const useGetUserOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getUserOptions>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getUserOptions>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getGetUserOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a one-time password reset link for a user.
 *
 * An authenticated user may create a link for their own password without
 * permissions.users:["update"]. Creating a link for another user requires
 * permissions.users:["update"] and access according to permissions.visibility:
 * global - any user in the current domain except the system administrator;
 * local - a user with at least one shared department;
 * basic - only the authenticated user.
 *
 * Only the system administrator can create a link for the system administrator.
 * The link can be created for a user in any status. Creating the link does not
 * change the user's password or status and does not affect active sessions.
 *
 * Previously issued password reset tokens for the user are invalidated.
 * A new one-time token valid for 30 minutes is associated with the user and domain.
 *
 * The URL is built using LUNA_POINT_2_UI_ORIGIN and
 * LUNA_POINT_2_PASSWORD_RESET_LINK_PATH. The token is passed in the token query
 * parameter. The user ID is not included in the URL.
 * @summary create password reset link
 */
export const createUserPasswordResetLink = (
    userId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<PasswordResetLink>(
      {url: `/1/users/${userId}/password_reset`, method: 'POST', signal
    },
      options);
    }




export const getCreateUserPasswordResetLinkMutationOptions = <TError = AuthorizationErrorResponse | PermissionErrorResponse | Error | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserPasswordResetLink>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserPasswordResetLink>>, TError,{userId: string}, TContext> => {

const mutationKey = ['createUserPasswordResetLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserPasswordResetLink>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  createUserPasswordResetLink(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateUserPasswordResetLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createUserPasswordResetLink>>>

    export type CreateUserPasswordResetLinkMutationError = AuthorizationErrorResponse | PermissionErrorResponse | Error | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary create password reset link
 */
export const useCreateUserPasswordResetLink = <TError = AuthorizationErrorResponse | PermissionErrorResponse | Error | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserPasswordResetLink>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserPasswordResetLink>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getCreateUserPasswordResetLinkMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary password reset link options
 */
export const getUserPasswordResetLinkOptions = (
    userId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/users/${userId}/password_reset`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetUserPasswordResetLinkOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getUserPasswordResetLinkOptions>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getUserPasswordResetLinkOptions>>, TError,{userId: string}, TContext> => {

const mutationKey = ['getUserPasswordResetLinkOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getUserPasswordResetLinkOptions>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  getUserPasswordResetLinkOptions(userId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetUserPasswordResetLinkOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getUserPasswordResetLinkOptions>>>

    export type GetUserPasswordResetLinkOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary password reset link options
 */
export const useGetUserPasswordResetLinkOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getUserPasswordResetLinkOptions>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getUserPasswordResetLinkOptions>>,
        TError,
        {userId: string},
        TContext
      > => {
      return useMutation(getGetUserPasswordResetLinkOptionsMutationOptions(options), queryClient);
    }

/**
 * Set a new password using a one-time password reset token.
 *
 * Standard LUNA POINT authorization is not required. The reset token is passed
 * in the Authorization header, and the new password is passed in the request body.
 * The user and domain are determined by the reset token.
 *
 * The reset token must exist, be valid, not expired and not previously used.
 * The new password must meet the password requirements.
 *
 * After a successful password change, a user in the pending status is moved
 * to active. The active and blocked statuses remain unchanged.
 * The reset token is invalidated and cannot be used again.
 *
 * Updating the password, changing the user status when required and invalidating
 * the reset token must be performed as a single atomic operation.
 * @summary confirm password reset
 */
export const confirmPasswordReset = (
    passwordResetConfirmRequest: PasswordResetConfirmRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/password_reset/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passwordResetConfirmRequest, signal
    },
      options);
    }




export const getConfirmPasswordResetMutationOptions = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError,{data: PasswordResetConfirmRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError,{data: PasswordResetConfirmRequest}, TContext> => {

const mutationKey = ['confirmPasswordReset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof confirmPasswordReset>>, {data: PasswordResetConfirmRequest}> = (props) => {
          const {data} = props ?? {};

          return  confirmPasswordReset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConfirmPasswordResetMutationResult = NonNullable<Awaited<ReturnType<typeof confirmPasswordReset>>>
    export type ConfirmPasswordResetMutationBody = PasswordResetConfirmRequest
    export type ConfirmPasswordResetMutationError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary confirm password reset
 */
export const useConfirmPasswordReset = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof confirmPasswordReset>>, TError,{data: PasswordResetConfirmRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof confirmPasswordReset>>,
        TError,
        {data: PasswordResetConfirmRequest},
        TContext
      > => {
      return useMutation(getConfirmPasswordResetMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary password reset confirmation options
 */
export const getPasswordResetConfirmationOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/password_reset/confirm`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetPasswordResetConfirmationOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPasswordResetConfirmationOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getPasswordResetConfirmationOptions>>, TError,void, TContext> => {

const mutationKey = ['getPasswordResetConfirmationOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPasswordResetConfirmationOptions>>, void> = () => {


          return  getPasswordResetConfirmationOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPasswordResetConfirmationOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getPasswordResetConfirmationOptions>>>

    export type GetPasswordResetConfirmationOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary password reset confirmation options
 */
export const useGetPasswordResetConfirmationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPasswordResetConfirmationOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPasswordResetConfirmationOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetPasswordResetConfirmationOptionsMutationOptions(options), queryClient);
    }

/**
 * @summary create role
 */
export const createRole = (
    createRoleRequest: CreateRoleRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreatedRole>(
      {url: `/1/roles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRoleRequest, signal
    },
      options);
    }




export const getCreateRoleMutationOptions = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleRequest}, TContext> => {

const mutationKey = ['createRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRole>>, {data: CreateRoleRequest}> = (props) => {
          const {data} = props ?? {};

          return  createRole(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRoleMutationResult = NonNullable<Awaited<ReturnType<typeof createRole>>>
    export type CreateRoleMutationBody = CreateRoleRequest
    export type CreateRoleMutationError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary create role
 */
export const useCreateRole = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRole>>, TError,{data: CreateRoleRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createRole>>,
        TError,
        {data: CreateRoleRequest},
        TContext
      > => {
      return useMutation(getCreateRoleMutationOptions(options), queryClient);
    }

/**
 * @summary get roles
 */
export const getRoles = (
    params?: GetRolesParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<RolesList>(
      {url: `/1/roles`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetRolesQueryKey = (params?: GetRolesParams,) => {
    return [
    `/1/roles`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRolesQueryOptions = <TData = Awaited<ReturnType<typeof getRoles>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRolesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRoles>>> = ({ signal }) => getRoles(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getRoles>>>
export type GetRolesQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetRoles<TData = Awaited<ReturnType<typeof getRoles>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetRolesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoles>>,
          TError,
          Awaited<ReturnType<typeof getRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoles<TData = Awaited<ReturnType<typeof getRoles>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRoles>>,
          TError,
          Awaited<ReturnType<typeof getRoles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoles<TData = Awaited<ReturnType<typeof getRoles>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get roles
 */

export function useGetRoles<TData = Awaited<ReturnType<typeof getRoles>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRoles>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRolesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary delete roles
 */
export const deleteRoles = (
    rolesToBeDeleted: RolesToBeDeleted,
    params?: DeleteRolesParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/roles`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: rolesToBeDeleted,
        params, signal
    },
      options);
    }




export const getDeleteRolesMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoles>>, TError,{data: RolesToBeDeleted;params?: DeleteRolesParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRoles>>, TError,{data: RolesToBeDeleted;params?: DeleteRolesParams}, TContext> => {

const mutationKey = ['deleteRoles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRoles>>, {data: RolesToBeDeleted;params?: DeleteRolesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteRoles(data,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteRoles>>, variables: {data: RolesToBeDeleted;params?: DeleteRolesParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetRolesQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteRolesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRoles>>>
    export type DeleteRolesMutationBody = RolesToBeDeleted
    export type DeleteRolesMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete roles
 */
export const useDeleteRoles = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRoles>>, TError,{data: RolesToBeDeleted;params?: DeleteRolesParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRoles>>,
        TError,
        {data: RolesToBeDeleted;params?: DeleteRolesParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteRolesMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary roles options
 */
export const getRolesOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/roles`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetRolesOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getRolesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getRolesOptions>>, TError,void, TContext> => {

const mutationKey = ['getRolesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getRolesOptions>>, void> = () => {


          return  getRolesOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetRolesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getRolesOptions>>>

    export type GetRolesOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary roles options
 */
export const useGetRolesOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getRolesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getRolesOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetRolesOptionsMutationOptions(options), queryClient);
    }

/**
 * Get roles count according to filters.
 *
 * **Visibility rules** (``permissions.visibility``):
 *
 * - ``"global"`` — counts all roles in the domain.
 * - ``"local"`` — counts roles with ``permissions.visibility`` equal
 *   to ``"local"`` or ``"basic"``.
 * - ``"basic"`` — counts only roles with
 *   ``permissions.visibility = "basic"``.
 *
 * A user without ``roles=read`` always counts only their own role,
 * regardless of visibility level, so the returned count is either ``0``
 * or ``1`` depending on the specified filters.
 *
 * All query parameters are applied on top of the visibility filter.
 * @summary get roles count
 */
export const getRolesCount = (
    params?: GetRolesCountParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<RolesCount>(
      {url: `/1/roles/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetRolesCountQueryKey = (params?: GetRolesCountParams,) => {
    return [
    `/1/roles/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRolesCountQueryOptions = <TData = Awaited<ReturnType<typeof getRolesCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetRolesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolesCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRolesCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRolesCount>>> = ({ signal }) => getRolesCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRolesCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRolesCountQueryResult = NonNullable<Awaited<ReturnType<typeof getRolesCount>>>
export type GetRolesCountQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetRolesCount<TData = Awaited<ReturnType<typeof getRolesCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetRolesCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolesCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRolesCount>>,
          TError,
          Awaited<ReturnType<typeof getRolesCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRolesCount<TData = Awaited<ReturnType<typeof getRolesCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetRolesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolesCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRolesCount>>,
          TError,
          Awaited<ReturnType<typeof getRolesCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRolesCount<TData = Awaited<ReturnType<typeof getRolesCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetRolesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolesCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get roles count
 */

export function useGetRolesCount<TData = Awaited<ReturnType<typeof getRolesCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetRolesCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRolesCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRolesCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * @summary get role
 */
export const getRole = (
    roleId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<RoleRecord>(
      {url: `/1/roles/${roleId}`, method: 'GET', signal
    },
      options);
    }




export const getGetRoleQueryKey = (roleId: string,) => {
    return [
    `/1/roles/${roleId}`
    ] as const;
    }


export const getGetRoleQueryOptions = <TData = Awaited<ReturnType<typeof getRole>>, TError = AuthorizationErrorResponse | Error | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(roleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRoleQueryKey(roleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRole>>> = ({ signal }) => getRole(roleId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: roleId !== null && roleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getRole>>>
export type GetRoleQueryError = AuthorizationErrorResponse | Error | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = AuthorizationErrorResponse | Error | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 roleId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRole>>,
          TError,
          Awaited<ReturnType<typeof getRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = AuthorizationErrorResponse | Error | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 roleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRole>>,
          TError,
          Awaited<ReturnType<typeof getRole>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = AuthorizationErrorResponse | Error | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 roleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get role
 */

export function useGetRole<TData = Awaited<ReturnType<typeof getRole>>, TError = AuthorizationErrorResponse | Error | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 roleId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRole>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRoleQueryOptions(roleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Partially update a role's fields: *name*, *description*, *permissions*. At least one field must be provided. System roles cannot be updated. If permissions are changed, token synchronization is performed and a 200 response is returned. Otherwise, a 204 response is returned.
 * @summary update role
 */
export const patchRole = (
    roleId: string,
    patchRoleRequest: PatchRoleRequest,
    params?: PatchRoleParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/roles/${roleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchRoleRequest,
        params, signal
    },
      options);
    }




export const getPatchRoleMutationOptions = <TError = Error | AuthorizationErrorResponse | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchRole>>, TError,{roleId: string;data: PatchRoleRequest;params?: PatchRoleParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchRole>>, TError,{roleId: string;data: PatchRoleRequest;params?: PatchRoleParams}, TContext> => {

const mutationKey = ['patchRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchRole>>, {roleId: string;data: PatchRoleRequest;params?: PatchRoleParams}> = (props) => {
          const {roleId,data,params} = props ?? {};

          return  patchRole(roleId,data,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof patchRole>>, variables: {roleId: string;data: PatchRoleRequest;params?: PatchRoleParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetRolesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetRoleQueryKey(variables.roleId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PatchRoleMutationResult = NonNullable<Awaited<ReturnType<typeof patchRole>>>
    export type PatchRoleMutationBody = PatchRoleRequest
    export type PatchRoleMutationError = Error | AuthorizationErrorResponse | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary update role
 */
export const usePatchRole = <TError = Error | AuthorizationErrorResponse | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchRole>>, TError,{roleId: string;data: PatchRoleRequest;params?: PatchRoleParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchRole>>,
        TError,
        {roleId: string;data: PatchRoleRequest;params?: PatchRoleParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPatchRoleMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * @summary delete role
 */
export const deleteRole = (
    roleId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/roles/${roleId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteRoleMutationOptions = <TError = AuthorizationErrorResponse | PermissionErrorResponse | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{roleId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{roleId: string}, TContext> => {

const mutationKey = ['deleteRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRole>>, {roleId: string}> = (props) => {
          const {roleId} = props ?? {};

          return  deleteRole(roleId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteRole>>, variables: {roleId: string}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetRolesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetRoleQueryKey(variables.roleId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteRoleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRole>>>

    export type DeleteRoleMutationError = AuthorizationErrorResponse | PermissionErrorResponse | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete role
 */
export const useDeleteRole = <TError = AuthorizationErrorResponse | PermissionErrorResponse | RoleNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRole>>, TError,{roleId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteRole>>,
        TError,
        {roleId: string},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteRoleMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary role options
 */
export const getRoleOptions = (
    roleId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/roles/${roleId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetRoleOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getRoleOptions>>, TError,{roleId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getRoleOptions>>, TError,{roleId: string}, TContext> => {

const mutationKey = ['getRoleOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getRoleOptions>>, {roleId: string}> = (props) => {
          const {roleId} = props ?? {};

          return  getRoleOptions(roleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetRoleOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getRoleOptions>>>

    export type GetRoleOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary role options
 */
export const useGetRoleOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getRoleOptions>>, TError,{roleId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getRoleOptions>>,
        TError,
        {roleId: string},
        TContext
      > => {
      return useMutation(getGetRoleOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a new permission tag within the authenticated user's domain
 * (``lp_account_id``).
 * @summary create permission tag
 */
export const createPermissionTag = (
    createPermissionTagRequest: CreatePermissionTagRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreatedPermissionTag>(
      {url: `/1/permission_tags`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPermissionTagRequest, signal
    },
      options);
    }




export const getCreatePermissionTagMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPermissionTag>>, TError,{data: CreatePermissionTagRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createPermissionTag>>, TError,{data: CreatePermissionTagRequest}, TContext> => {

const mutationKey = ['createPermissionTag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPermissionTag>>, {data: CreatePermissionTagRequest}> = (props) => {
          const {data} = props ?? {};

          return  createPermissionTag(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createPermissionTag>>, variables: {data: CreatePermissionTagRequest}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetPermissionTagsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreatePermissionTagMutationResult = NonNullable<Awaited<ReturnType<typeof createPermissionTag>>>
    export type CreatePermissionTagMutationBody = CreatePermissionTagRequest
    export type CreatePermissionTagMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary create permission tag
 */
export const useCreatePermissionTag = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPermissionTag>>, TError,{data: CreatePermissionTagRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPermissionTag>>,
        TError,
        {data: CreatePermissionTagRequest},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreatePermissionTagMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Return permission tags visible to the authenticated user.
 *
 * Visibility rules depend on ``permissions.visibility``:
 *
 * * ``global`` - all permission tags within the user's domain are visible.
 * * ``local`` - permission tags linked to at least one of the user's
 *   departments are visible regardless of the ``open`` value. Permission tags
 *   created by the requesting user are also visible.
 * * ``basic`` - permission tags linked to at least one of the user's
 *   departments are visible only when
 *   ``departments.permission_tags.open = true``. Permission tags created by
 *   the requesting user are also visible.
 *
 * All query parameters are applied on top of the visibility filter.
 * Supports ``%ILIKE%`` filtering via the ``permission_tags`` query
 * parameter.
 * @summary get permission tags
 */
export const getPermissionTags = (
    params?: GetPermissionTagsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<PermissionTagsList>(
      {url: `/1/permission_tags`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPermissionTagsQueryKey = (params?: GetPermissionTagsParams,) => {
    return [
    `/1/permission_tags`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPermissionTagsQueryOptions = <TData = Awaited<ReturnType<typeof getPermissionTags>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetPermissionTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionTags>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionTagsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermissionTags>>> = ({ signal }) => getPermissionTags(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPermissionTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPermissionTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getPermissionTags>>>
export type GetPermissionTagsQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetPermissionTags<TData = Awaited<ReturnType<typeof getPermissionTags>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetPermissionTagsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionTags>>,
          TError,
          Awaited<ReturnType<typeof getPermissionTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissionTags<TData = Awaited<ReturnType<typeof getPermissionTags>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetPermissionTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionTags>>,
          TError,
          Awaited<ReturnType<typeof getPermissionTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissionTags<TData = Awaited<ReturnType<typeof getPermissionTags>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetPermissionTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionTags>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get permission tags
 */

export function useGetPermissionTags<TData = Awaited<ReturnType<typeof getPermissionTags>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetPermissionTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionTags>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPermissionTagsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete several permission tags.
 *
 * Only tags visible to the requesting user may be deleted.
 * Visibility rules are the same as for ``GET /permission_tags``.
 *
 * When ``ignore=0`` (default):
 *
 * * Tag not found in domain → 422 ``PermissionTagNotFound``.
 * * Tag exists but not accessible to the user → 403
 *   ``PermissionTagAccessDenied``.
 *
 * When ``ignore=1``, tags the user cannot access are silently skipped.
 * @summary delete permission_tags
 */
export const deletePermissionTags = (
    permissionTagsToBeDeleted?: PermissionTagsToBeDeleted,
    params?: DeletePermissionTagsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/permission_tags`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: permissionTagsToBeDeleted,
        params, signal
    },
      options);
    }




export const getDeletePermissionTagsMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePermissionTags>>, TError,{data?: PermissionTagsToBeDeleted;params?: DeletePermissionTagsParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePermissionTags>>, TError,{data?: PermissionTagsToBeDeleted;params?: DeletePermissionTagsParams}, TContext> => {

const mutationKey = ['deletePermissionTags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePermissionTags>>, {data?: PermissionTagsToBeDeleted;params?: DeletePermissionTagsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deletePermissionTags(data,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deletePermissionTags>>, variables: {data?: PermissionTagsToBeDeleted;params?: DeletePermissionTagsParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetPermissionTagsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeletePermissionTagsMutationResult = NonNullable<Awaited<ReturnType<typeof deletePermissionTags>>>
    export type DeletePermissionTagsMutationBody = PermissionTagsToBeDeleted | undefined
    export type DeletePermissionTagsMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete permission_tags
 */
export const useDeletePermissionTags = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePermissionTags>>, TError,{data?: PermissionTagsToBeDeleted;params?: DeletePermissionTagsParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePermissionTags>>,
        TError,
        {data?: PermissionTagsToBeDeleted;params?: DeletePermissionTagsParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeletePermissionTagsMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary get permission tags options
 */
export const getPermissionTagsOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/permission_tags`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetPermissionTagsOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPermissionTagsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getPermissionTagsOptions>>, TError,void, TContext> => {

const mutationKey = ['getPermissionTagsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPermissionTagsOptions>>, void> = () => {


          return  getPermissionTagsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPermissionTagsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getPermissionTagsOptions>>>

    export type GetPermissionTagsOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary get permission tags options
 */
export const useGetPermissionTagsOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPermissionTagsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPermissionTagsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetPermissionTagsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get permission tags count according to filters.
 *
 * Visibility rules are the same as for GET /permission_tags and depend on
 * ``permissions.visibility``:
 *
 * * ``global`` - all permission tags within the user's domain are counted.
 * * ``local`` - permission tags linked to at least one of the user's
 *   departments are counted regardless of the ``open`` value. Permission tags
 *   created by the requesting user are also counted.
 * * ``basic`` - permission tags linked to at least one of the user's
 *   departments are counted only when
 *   ``departments.permission_tags.open = true``. Permission tags created by
 *   the requesting user are also counted.
 *
 * All query parameters are applied on top of the visibility filter.
 *
 * Sorting and pagination are not used for this method because the method
 * returns aggregated permission tags count only.
 * @summary get permission tags count
 */
export const getPermissionTagsCount = (
    params?: GetPermissionTagsCountParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<PermissionTagsCount>(
      {url: `/1/permission_tags/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPermissionTagsCountQueryKey = (params?: GetPermissionTagsCountParams,) => {
    return [
    `/1/permission_tags/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPermissionTagsCountQueryOptions = <TData = Awaited<ReturnType<typeof getPermissionTagsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetPermissionTagsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionTagsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPermissionTagsCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPermissionTagsCount>>> = ({ signal }) => getPermissionTagsCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPermissionTagsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPermissionTagsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getPermissionTagsCount>>>
export type GetPermissionTagsCountQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetPermissionTagsCount<TData = Awaited<ReturnType<typeof getPermissionTagsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetPermissionTagsCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionTagsCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionTagsCount>>,
          TError,
          Awaited<ReturnType<typeof getPermissionTagsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissionTagsCount<TData = Awaited<ReturnType<typeof getPermissionTagsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetPermissionTagsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionTagsCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPermissionTagsCount>>,
          TError,
          Awaited<ReturnType<typeof getPermissionTagsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPermissionTagsCount<TData = Awaited<ReturnType<typeof getPermissionTagsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetPermissionTagsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionTagsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get permission tags count
 */

export function useGetPermissionTagsCount<TData = Awaited<ReturnType<typeof getPermissionTagsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetPermissionTagsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPermissionTagsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPermissionTagsCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Create a new department within the authenticated user's domain
 * (``lp_account_id``).
 *
 * Each entry in ``permission_tags`` and ``lists`` must reference a
 * permission tag / list that exists in the current domain, and each
 * array must not contain duplicate ``permission_tag`` / ``list_id``
 * values.
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * * ``"global"`` — can reference any ``parent_department_id``,
 *   ``permission_tags``, and ``lists`` in the domain.
 * * ``"local"`` — ``parent_department_id`` must be an own department;
 *   ``permission_tags`` must be accessible (in user's departments or
 *   created by user); ``lists`` must be in user's departments.
 * * ``"basic"`` — same as ``"local"`` for parent; ``permission_tags``
 *   must be open (``open=true``) in user's departments or created by
 *   user; ``lists`` must be open in user's departments.
 * @summary create department
 */
export const createDepartment = (
    createDepartmentRequest: CreateDepartmentRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreatedDepartment>(
      {url: `/1/departments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDepartmentRequest, signal
    },
      options);
    }




export const getCreateDepartmentMutationOptions = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: CreateDepartmentRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: CreateDepartmentRequest}, TContext> => {

const mutationKey = ['createDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDepartment>>, {data: CreateDepartmentRequest}> = (props) => {
          const {data} = props ?? {};

          return  createDepartment(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof createDepartment>>>
    export type CreateDepartmentMutationBody = CreateDepartmentRequest
    export type CreateDepartmentMutationError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary create department
 */
export const useCreateDepartment = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDepartment>>, TError,{data: CreateDepartmentRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDepartment>>,
        TError,
        {data: CreateDepartmentRequest},
        TContext
      > => {
      return useMutation(getCreateDepartmentMutationOptions(options), queryClient);
    }

/**
 * Return departments within the authenticated user's domain.
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * * ``"global"`` — all departments in the domain matching filters
 *   (requires ``departments=read``).
 * * ``"local"`` — departments the user belongs to, full records.
 * * ``"basic"`` — departments the user belongs to, with
 *   ``open=false`` permission tags and lists filtered out.
 *
 * A user can always see their own departments, even without
 * ``departments=read``.
 * @summary get departments
 */
export const getDepartments = (
    params?: GetDepartmentsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<DepartmentsList>(
      {url: `/1/departments`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetDepartmentsInfiniteQueryKey = (params?: GetDepartmentsParams,) => {
    return [
    'infinite', `/1/departments`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetDepartmentsQueryKey = (params?: GetDepartmentsParams,) => {
    return [
    `/1/departments`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDepartmentsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getDepartments>>, GetDepartmentsParams['page']>, TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetDepartmentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData, QueryKey, GetDepartmentsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartments>>, QueryKey, GetDepartmentsParams['page']> = ({ signal, pageParam }) => getDepartments({...params, 'page': pageParam ?? params?.['page']}, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData, QueryKey, GetDepartmentsParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepartmentsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartments>>>
export type GetDepartmentsInfiniteQueryError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetDepartmentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDepartments>>, GetDepartmentsParams['page']>, TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetDepartmentsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData, QueryKey, GetDepartmentsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartments>>,
          TError,
          Awaited<ReturnType<typeof getDepartments>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDepartments>>, GetDepartmentsParams['page']>, TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetDepartmentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData, QueryKey, GetDepartmentsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartments>>,
          TError,
          Awaited<ReturnType<typeof getDepartments>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDepartments>>, GetDepartmentsParams['page']>, TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetDepartmentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData, QueryKey, GetDepartmentsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get departments
 */

export function useGetDepartmentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getDepartments>>, GetDepartmentsParams['page']>, TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetDepartmentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData, QueryKey, GetDepartmentsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepartmentsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDepartmentsQueryOptions = <TData = Awaited<ReturnType<typeof getDepartments>>, TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartments>>> = ({ signal }) => getDepartments(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepartmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartments>>>
export type GetDepartmentsQueryError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetDepartments<TData = Awaited<ReturnType<typeof getDepartments>>, TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetDepartmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartments>>,
          TError,
          Awaited<ReturnType<typeof getDepartments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartments<TData = Awaited<ReturnType<typeof getDepartments>>, TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartments>>,
          TError,
          Awaited<ReturnType<typeof getDepartments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartments<TData = Awaited<ReturnType<typeof getDepartments>>, TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get departments
 */

export function useGetDepartments<TData = Awaited<ReturnType<typeof getDepartments>>, TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetDepartmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartments>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepartmentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Bulk-delete departments by ID list.
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * * ``"global"`` — any departments in the domain.
 * * ``"local"`` / ``"basic"`` — only departments the user belongs to.
 *
 * With ``ignore=0`` (default): all requested IDs must be accessible to
 * the user; the first inaccessible ID causes a 403 and nothing is deleted.
 * With ``ignore=1``: inaccessible departments are silently skipped and
 * only the accessible subset is deleted.
 *
 * Use ``ignore=1`` to also silently skip departments that do not exist
 * instead of returning 422.
 * @summary delete departments
 */
export const deleteDepartments = (
    deleteDepartmentsRequest: DeleteDepartmentsRequest,
    params?: DeleteDepartmentsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/departments`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteDepartmentsRequest,
        params, signal
    },
      options);
    }




export const getDeleteDepartmentsMutationOptions = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartments>>, TError,{data: DeleteDepartmentsRequest;params?: DeleteDepartmentsParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDepartments>>, TError,{data: DeleteDepartmentsRequest;params?: DeleteDepartmentsParams}, TContext> => {

const mutationKey = ['deleteDepartments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDepartments>>, {data: DeleteDepartmentsRequest;params?: DeleteDepartmentsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteDepartments(data,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteDepartments>>, variables: {data: DeleteDepartmentsRequest;params?: DeleteDepartmentsParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetDepartmentsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteDepartmentsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDepartments>>>
    export type DeleteDepartmentsMutationBody = DeleteDepartmentsRequest
    export type DeleteDepartmentsMutationError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete departments
 */
export const useDeleteDepartments = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartments>>, TError,{data: DeleteDepartmentsRequest;params?: DeleteDepartmentsParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDepartments>>,
        TError,
        {data: DeleteDepartmentsRequest;params?: DeleteDepartmentsParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteDepartmentsMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary get departments options
 */
export const getDepartmentsOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/departments`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetDepartmentsOptionsMutationOptions = <TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDepartmentsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getDepartmentsOptions>>, TError,void, TContext> => {

const mutationKey = ['getDepartmentsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getDepartmentsOptions>>, void> = () => {


          return  getDepartmentsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetDepartmentsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getDepartmentsOptions>>>

    export type GetDepartmentsOptionsMutationError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary get departments options
 */
export const useGetDepartmentsOptions = <TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDepartmentsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getDepartmentsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetDepartmentsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get department by ID.
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * * ``"global"`` — can fetch any department in the domain (requires
 *   ``departments=read``).
 * * ``"local"`` — must be one of the user's departments.
 * * ``"basic"`` — must be one of the user's departments; ``open=false``
 *   permission tags and lists are filtered out.
 *
 * A user can always fetch their own departments, even without
 * ``departments=read``.
 * @summary get department
 */
export const getDepartment = (
    departmentId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<DepartmentRecord>(
      {url: `/1/departments/${departmentId}`, method: 'GET', signal
    },
      options);
    }




export const getGetDepartmentQueryKey = (departmentId: string,) => {
    return [
    `/1/departments/${departmentId}`
    ] as const;
    }


export const getGetDepartmentQueryOptions = <TData = Awaited<ReturnType<typeof getDepartment>>, TError = AuthorizationErrorResponse | Error | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(departmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentQueryKey(departmentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartment>>> = ({ signal }) => getDepartment(departmentId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: departmentId !== null && departmentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepartmentQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartment>>>
export type GetDepartmentQueryError = AuthorizationErrorResponse | Error | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = AuthorizationErrorResponse | Error | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 departmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartment>>,
          TError,
          Awaited<ReturnType<typeof getDepartment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = AuthorizationErrorResponse | Error | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 departmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartment>>,
          TError,
          Awaited<ReturnType<typeof getDepartment>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = AuthorizationErrorResponse | Error | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 departmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get department
 */

export function useGetDepartment<TData = Awaited<ReturnType<typeof getDepartment>>, TError = AuthorizationErrorResponse | Error | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 departmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartment>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepartmentQueryOptions(departmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Partially update a department's fields. Only fields present in the
 * request body are modified; omitted fields are left unchanged.
 * When ``permission_tags`` is provided (even as an empty array) the
 * department's existing tag set is fully replaced.
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * * ``"global"`` — can update any department and reference any
 *   ``parent_department_id`` / ``permission_tags`` in the domain.
 * * ``"local"`` — can only update own departments; ``parent_department_id``
 *   must be an own department; ``permission_tags`` must be accessible
 *   (in user's departments or created by user).
 * * ``"basic"`` — same as ``"local"`` for department/parent access;
 *   ``permission_tags`` must be open (``open=true``) in user's
 *   departments or created by user.
 * @summary update department
 */
export const patchDepartment = (
    departmentId: string,
    patchDepartmentRequest: PatchDepartmentRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/departments/${departmentId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchDepartmentRequest, signal
    },
      options);
    }




export const getPatchDepartmentMutationOptions = <TError = Error | AuthorizationErrorResponse | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchDepartment>>, TError,{departmentId: string;data: PatchDepartmentRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchDepartment>>, TError,{departmentId: string;data: PatchDepartmentRequest}, TContext> => {

const mutationKey = ['patchDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchDepartment>>, {departmentId: string;data: PatchDepartmentRequest}> = (props) => {
          const {departmentId,data} = props ?? {};

          return  patchDepartment(departmentId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof patchDepartment>>, variables: {departmentId: string;data: PatchDepartmentRequest}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetDepartmentsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetDepartmentQueryKey(variables.departmentId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PatchDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof patchDepartment>>>
    export type PatchDepartmentMutationBody = PatchDepartmentRequest
    export type PatchDepartmentMutationError = Error | AuthorizationErrorResponse | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary update department
 */
export const usePatchDepartment = <TError = Error | AuthorizationErrorResponse | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchDepartment>>, TError,{departmentId: string;data: PatchDepartmentRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchDepartment>>,
        TError,
        {departmentId: string;data: PatchDepartmentRequest},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPatchDepartmentMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Delete department by ID.
 *
 * The requesting user must have ``departments=delete`` permission.
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * * ``"global"`` — can delete any department in the domain.
 * * ``"local"`` / ``"basic"`` — can only delete own departments.
 *
 * Both a missing department and an inaccessible one return 404 to prevent
 * enumeration.
 * @summary delete department
 */
export const deleteDepartment = (
    departmentId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/departments/${departmentId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteDepartmentMutationOptions = <TError = AuthorizationErrorResponse | Error | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{departmentId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{departmentId: string}, TContext> => {

const mutationKey = ['deleteDepartment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDepartment>>, {departmentId: string}> = (props) => {
          const {departmentId} = props ?? {};

          return  deleteDepartment(departmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDepartmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDepartment>>>

    export type DeleteDepartmentMutationError = AuthorizationErrorResponse | Error | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete department
 */
export const useDeleteDepartment = <TError = AuthorizationErrorResponse | Error | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDepartment>>, TError,{departmentId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDepartment>>,
        TError,
        {departmentId: string},
        TContext
      > => {
      return useMutation(getDeleteDepartmentMutationOptions(options), queryClient);
    }

/**
 * Create a new card.
 *
 * Visibility rules for ``lists``:
 *
 * * ``"global"`` — any lists in the domain.
 * * ``"local"`` — only lists accessible to the user's departments.
 * * ``"basic"`` — only open lists accessible to the user's departments.
 * @summary create a card
 */
export const createCard = (
    cardToBeCreated: CardToBeCreated,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreateCardResponse>(
      {url: `/1/cards`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cardToBeCreated, signal
    },
      options);
    }




export const getCreateCardMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: CardToBeCreated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: CardToBeCreated}, TContext> => {

const mutationKey = ['createCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCard>>, {data: CardToBeCreated}> = (props) => {
          const {data} = props ?? {};

          return  createCard(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createCard>>, variables: {data: CardToBeCreated}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetCardsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardsCountQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateCardMutationResult = NonNullable<Awaited<ReturnType<typeof createCard>>>
    export type CreateCardMutationBody = CardToBeCreated
    export type CreateCardMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse

    /**
 * @summary create a card
 */
export const useCreateCard = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: CardToBeCreated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCard>>,
        TError,
        {data: CardToBeCreated},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateCardMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Delete several cards.
 *
 * Visibility rules:
 *
 * * ``"global"`` — any cards in the domain.
 * * ``"local"`` — only cards from lists accessible to the user's departments.
 * * ``"basic"`` — only cards from open lists accessible to the user's departments.
 * @summary delete cards
 */
export const deleteCards = (
    cardsToBeDeleted: CardsToBeDeleted,
    params?: DeleteCardsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/cards`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: cardsToBeDeleted,
        params, signal
    },
      options);
    }




export const getDeleteCardsMutationOptions = <TError = Error | CardNotFoundResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCards>>, TError,{data: CardsToBeDeleted;params?: DeleteCardsParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCards>>, TError,{data: CardsToBeDeleted;params?: DeleteCardsParams}, TContext> => {

const mutationKey = ['deleteCards'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCards>>, {data: CardsToBeDeleted;params?: DeleteCardsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteCards(data,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteCards>>, variables: {data: CardsToBeDeleted;params?: DeleteCardsParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetCardsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardsCountQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteCardsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCards>>>
    export type DeleteCardsMutationBody = CardsToBeDeleted
    export type DeleteCardsMutationError = Error | CardNotFoundResponse

    /**
 * @summary delete cards
 */
export const useDeleteCards = <TError = Error | CardNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCards>>, TError,{data: CardsToBeDeleted;params?: DeleteCardsParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCards>>,
        TError,
        {data: CardsToBeDeleted;params?: DeleteCardsParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteCardsMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get cards according to filters.
 *
 * Visibility rules:
 *
 * * ``"global"`` — all cards matching filters.
 * * ``"local"`` — cards from lists accessible to the user's departments.
 * * ``"basic"`` — cards from open lists accessible to the user's departments.
 * @summary get cards
 */
export const getCards = (
    params?: GetCardsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<GetCards200>(
      {url: `/1/cards`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCardsQueryKey = (params?: GetCardsParams,) => {
    return [
    `/1/cards`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCardsQueryOptions = <TData = Awaited<ReturnType<typeof getCards>>, TError = Error | InternalServerErrorResponse>(params?: GetCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCardsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCards>>> = ({ signal }) => getCards(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCardsQueryResult = NonNullable<Awaited<ReturnType<typeof getCards>>>
export type GetCardsQueryError = Error | InternalServerErrorResponse


export function useGetCards<TData = Awaited<ReturnType<typeof getCards>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetCardsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCards>>,
          TError,
          Awaited<ReturnType<typeof getCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCards<TData = Awaited<ReturnType<typeof getCards>>, TError = Error | InternalServerErrorResponse>(
 params?: GetCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCards>>,
          TError,
          Awaited<ReturnType<typeof getCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCards<TData = Awaited<ReturnType<typeof getCards>>, TError = Error | InternalServerErrorResponse>(
 params?: GetCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get cards
 */

export function useGetCards<TData = Awaited<ReturnType<typeof getCards>>, TError = Error | InternalServerErrorResponse>(
 params?: GetCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCardsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary cards options
 */
export const getCardsOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/cards`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetCardsOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCardsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getCardsOptions>>, TError,void, TContext> => {

const mutationKey = ['getCardsOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCardsOptions>>, void> = () => {


          return  getCardsOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetCardsOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getCardsOptions>>>

    export type GetCardsOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary cards options
 */
export const useGetCardsOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCardsOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCardsOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetCardsOptionsMutationOptions(options), queryClient);
    }

/**
 * Get cards count according to filters.
 *
 * Sorting is not used for this method because the method returns aggregated cards count only.
 * @summary get cards count
 */
export const getCardsCount = (
    params?: GetCardsCountParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CardsCount>(
      {url: `/1/cards/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCardsCountQueryKey = (params?: GetCardsCountParams,) => {
    return [
    `/1/cards/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCardsCountQueryOptions = <TData = Awaited<ReturnType<typeof getCardsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetCardsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCardsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCardsCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCardsCount>>> = ({ signal }) => getCardsCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCardsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCardsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getCardsCount>>>
export type GetCardsCountQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetCardsCount<TData = Awaited<ReturnType<typeof getCardsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetCardsCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCardsCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCardsCount>>,
          TError,
          Awaited<ReturnType<typeof getCardsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCardsCount<TData = Awaited<ReturnType<typeof getCardsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetCardsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCardsCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCardsCount>>,
          TError,
          Awaited<ReturnType<typeof getCardsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCardsCount<TData = Awaited<ReturnType<typeof getCardsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetCardsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCardsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get cards count
 */

export function useGetCardsCount<TData = Awaited<ReturnType<typeof getCardsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetCardsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCardsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCardsCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get card by ID.
 *
 * Returns the card only if it belongs to the requesting user's domain.
 *
 * Visibility rules:
 *
 * * ``"global"`` — any card in the domain.
 * * ``"local"`` — only cards from lists accessible to the user's departments.
 * * ``"basic"`` — only cards from open lists accessible to the user's departments.
 * @summary get card
 */
export const getCard = (
    cardId: CardId,
    params?: GetCardParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<Card & Required<Pick<Card, 'card_id'>>>(
      {url: `/1/cards/${cardId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCardQueryKey = (cardId: CardId,
    params?: GetCardParams,) => {
    return [
    `/1/cards/${cardId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCardQueryOptions = <TData = Awaited<ReturnType<typeof getCard>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse | InternalServerErrorResponse>(cardId: CardId,
    params?: GetCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCardQueryKey(cardId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCard>>> = ({ signal }) => getCard(cardId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: cardId !== null && cardId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCardQueryResult = NonNullable<Awaited<ReturnType<typeof getCard>>>
export type GetCardQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse | InternalServerErrorResponse


export function useGetCard<TData = Awaited<ReturnType<typeof getCard>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse | InternalServerErrorResponse>(
 cardId: CardId,
    params: undefined |  GetCardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCard>>,
          TError,
          Awaited<ReturnType<typeof getCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCard<TData = Awaited<ReturnType<typeof getCard>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse | InternalServerErrorResponse>(
 cardId: CardId,
    params?: GetCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCard>>,
          TError,
          Awaited<ReturnType<typeof getCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCard<TData = Awaited<ReturnType<typeof getCard>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse | InternalServerErrorResponse>(
 cardId: CardId,
    params?: GetCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get card
 */

export function useGetCard<TData = Awaited<ReturnType<typeof getCard>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse | InternalServerErrorResponse>(
 cardId: CardId,
    params?: GetCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCardQueryOptions(cardId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Put (replace) a card.
 *
 * Replaces all parameters of the card with the provided values.
 *
 * The card can be attached to one or several lists.
 * If `main_face_id` is provided, the face must not be linked to a different card.
 *
 * If the face specified in `main_face_id` is not linked to the card yet, it is added to the card
 * and attached to all lists of the card.
 *
 * All other faces of the card are unlinked from it: they are detached from the card lists and
 * their `external_id` is cleared, the faces themselves are not deleted. Without `main_face_id`
 * the card is left without faces.
 * @summary put card
 */
export const putCard = (
    cardId: CardId,
    cardToBeUpdated: CardToBeUpdated,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreateCardResponse>(
      {url: `/1/cards/${cardId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cardToBeUpdated, signal
    },
      options);
    }




export const getPutCardMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCard>>, TError,{cardId: CardId;data: CardToBeUpdated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putCard>>, TError,{cardId: CardId;data: CardToBeUpdated}, TContext> => {

const mutationKey = ['putCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCard>>, {cardId: CardId;data: CardToBeUpdated}> = (props) => {
          const {cardId,data} = props ?? {};

          return  putCard(cardId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof putCard>>, variables: {cardId: CardId;data: CardToBeUpdated}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetCardsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardsCountQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PutCardMutationResult = NonNullable<Awaited<ReturnType<typeof putCard>>>
    export type PutCardMutationBody = CardToBeUpdated
    export type PutCardMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse

    /**
 * @summary put card
 */
export const usePutCard = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCard>>, TError,{cardId: CardId;data: CardToBeUpdated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCard>>,
        TError,
        {cardId: CardId;data: CardToBeUpdated},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPutCardMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Partially update card fields.
 *
 * Only the provided fields are updated; omitted fields remain unchanged.
 *
 * If `main_face_id` is provided, the face must not be linked to a different card.
 *
 * If the face specified in `main_face_id` is not linked to the card yet, it is added to the card
 * and attached to all lists of the card.
 *
 * Visibility rules for ``/{card_id}``:
 *
 * * ``"global"`` — any card in the domain.
 * * ``"local"`` — only cards from lists accessible to the user's departments.
 * * ``"basic"`` — only cards from open lists accessible to the user's departments.
 *
 * Visibility rules for ``lists``:
 *
 * * ``"global"`` — any lists in the domain.
 * * ``"local"`` — only lists accessible to the user's departments.
 * * ``"basic"`` — only open lists accessible to the user's departments.
 * @summary update card
 */
export const patchCard = (
    cardId: CardId,
    cardToBeUpdated: CardToBeUpdated,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/cards/${cardId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: cardToBeUpdated, signal
    },
      options);
    }




export const getPatchCardMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCard>>, TError,{cardId: CardId;data: CardToBeUpdated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCard>>, TError,{cardId: CardId;data: CardToBeUpdated}, TContext> => {

const mutationKey = ['patchCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCard>>, {cardId: CardId;data: CardToBeUpdated}> = (props) => {
          const {cardId,data} = props ?? {};

          return  patchCard(cardId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof patchCard>>, variables: {cardId: CardId;data: CardToBeUpdated}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetCardsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardsCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetFacesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardQueryKey(variables.cardId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PatchCardMutationResult = NonNullable<Awaited<ReturnType<typeof patchCard>>>
    export type PatchCardMutationBody = CardToBeUpdated
    export type PatchCardMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse

    /**
 * @summary update card
 */
export const usePatchCard = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCard>>, TError,{cardId: CardId;data: CardToBeUpdated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCard>>,
        TError,
        {cardId: CardId;data: CardToBeUpdated},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPatchCardMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Remove card by ID.
 *
 * Deletes the card and all its contents.
 *
 * Visibility rules:
 *
 * * ``"global"`` — any card in the domain.
 * * ``"local"`` — only cards from lists accessible to the user's departments.
 * * ``"basic"`` — only cards from open lists accessible to the user's departments.
 * @summary delete card
 */
export const deleteCard = (
    cardId: CardId,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/cards/${cardId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteCardMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{cardId: CardId}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{cardId: CardId}, TContext> => {

const mutationKey = ['deleteCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCard>>, {cardId: CardId}> = (props) => {
          const {cardId} = props ?? {};

          return  deleteCard(cardId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteCard>>, variables: {cardId: CardId}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetCardsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardsCountQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteCardMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCard>>>

    export type DeleteCardMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse

    /**
 * @summary delete card
 */
export const useDeleteCard = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | CardNotFoundResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{cardId: CardId}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCard>>,
        TError,
        {cardId: CardId},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteCardMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Check existence of the card by ID.
 *
 * Returns 200 if the card exists in the requesting user's domain, or 404 if not found.
 *
 * Visibility rules:
 *
 * * ``"global"`` — any card in the domain.
 * * ``"local"`` — only cards from lists accessible to the user's departments.
 * * ``"basic"`` — only cards from open lists accessible to the user's departments.
 * @summary check card existence
 */
export const checkCard = (
    cardId: CardId,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/cards/${cardId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckCardMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkCard>>, TError,{cardId: CardId}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkCard>>, TError,{cardId: CardId}, TContext> => {

const mutationKey = ['checkCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkCard>>, {cardId: CardId}> = (props) => {
          const {cardId} = props ?? {};

          return  checkCard(cardId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckCardMutationResult = NonNullable<Awaited<ReturnType<typeof checkCard>>>

    export type CheckCardMutationError = void

    /**
 * @summary check card existence
 */
export const useCheckCard = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkCard>>, TError,{cardId: CardId}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkCard>>,
        TError,
        {cardId: CardId},
        TContext
      > => {
      return useMutation(getCheckCardMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary get card options
 */
export const getCardOptions = (
    cardId: CardId,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/cards/${cardId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetCardOptionsMutationOptions = <TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCardOptions>>, TError,{cardId: CardId}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getCardOptions>>, TError,{cardId: CardId}, TContext> => {

const mutationKey = ['getCardOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCardOptions>>, {cardId: CardId}> = (props) => {
          const {cardId} = props ?? {};

          return  getCardOptions(cardId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetCardOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getCardOptions>>>

    export type GetCardOptionsMutationError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary get card options
 */
export const useGetCardOptions = <TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCardOptions>>, TError,{cardId: CardId}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCardOptions>>,
        TError,
        {cardId: CardId},
        TContext
      > => {
      return useMutation(getGetCardOptionsMutationOptions(options), queryClient);
    }

/**
 * Create a face.
 *
 * The face can be attached to card by setting existing card_id parameter.
 *
 * You can create new face using a temporary attribute ID or using external attribute data (descriptors and/or basic attributes).
 *
 * You can also create the face without any attributes specified.
 *
 * **Visibility rules for card_id:**
 *
 * - `"global"` — any card in the domain.
 * - `"local"` — only cards from lists accessible to the user's departments. Returns 403 otherwise.
 * - `"basic"` — only cards from open lists accessible to the user's departments. Returns 403 otherwise.
 * @summary create face
 */
export const createFace = (
    createFaceBody: FaceToBeCreated | FaceToBeCreatedBinary,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreateFace201>(
      {url: `/1/faces`, method: 'POST',
      data: createFaceBody, signal
    },
      options);
    }




export const getCreateFaceMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFace>>, TError,{data: FaceToBeCreated | FaceToBeCreatedBinary}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createFace>>, TError,{data: FaceToBeCreated | FaceToBeCreatedBinary}, TContext> => {

const mutationKey = ['createFace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFace>>, {data: FaceToBeCreated | FaceToBeCreatedBinary}> = (props) => {
          const {data} = props ?? {};

          return  createFace(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createFace>>, variables: {data: FaceToBeCreated | FaceToBeCreatedBinary}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetFacesQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateFaceMutationResult = NonNullable<Awaited<ReturnType<typeof createFace>>>
    export type CreateFaceMutationBody = FaceToBeCreated | FaceToBeCreatedBinary
    export type CreateFaceMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary create face
 */
export const useCreateFace = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFace>>, TError,{data: FaceToBeCreated | FaceToBeCreatedBinary}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFace>>,
        TError,
        {data: FaceToBeCreated | FaceToBeCreatedBinary},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateFaceMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get faces by IDs.
 *
 * At least one of `face_ids`, `card_ids` must be specified, otherwise the request is rejected with an error.
 * A specified parameter must carry at least one ID, an empty value is rejected as a malformed filter.
 * If both parameters are specified, they are combined with `AND`.
 *
 * The response is not paginated: every matching face is returned.
 *
 * **Visibility rules for returned records:**
 *
 * - `"global"` — all faces matching filters.
 * - `"local"` — only faces linked to cards from lists accessible to the user's departments.
 * - `"basic"` — only faces linked to cards from open lists accessible to the user's departments.
 * @summary get faces
 */
export const getFaces = (
    params?: GetFacesParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<GetFaces200>(
      {url: `/1/faces`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFacesQueryKey = (params?: GetFacesParams,) => {
    return [
    `/1/faces`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFacesQueryOptions = <TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse>(params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFacesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFaces>>> = ({ signal }) => getFaces(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFacesQueryResult = NonNullable<Awaited<ReturnType<typeof getFaces>>>
export type GetFacesQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse


export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse>(
 params: undefined |  GetFacesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaces>>,
          TError,
          Awaited<ReturnType<typeof getFaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse>(
 params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaces>>,
          TError,
          Awaited<ReturnType<typeof getFaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse>(
 params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get faces
 */

export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse>(
 params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFacesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete several faces by IDs.
 *
 * When the faces are removed, attributes (descriptors and basic attributes) linked to the faces are deleted.
 * Samples linked to the faces are not deleted.
 *
 * If you need to delete faces according to some filters and with all samples,
 * you can use the ["garbage collection task"](operation/createGCTask) with `target = faces` and `remove_samples` flag enabled.
 *
 * **Visibility rules:**
 *
 * - `"global"` — any faces in the domain.
 * - `"local"` — only faces linked to cards from lists accessible to the user's departments.
 * - `"basic"` — only faces linked to cards from open lists accessible to the user's departments.
 *
 * **Owner department rule:** User must be a member of all `owner_department`s of the card's lists.
 * @summary delete faces
 */
export const deleteFaces = (
    facesToBeDeleted?: FacesToBeDeleted,
    params?: DeleteFacesParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/faces`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: facesToBeDeleted,
        params, signal
    },
      options);
    }




export const getDeleteFacesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFaces>>, TError,{data?: FacesToBeDeleted;params?: DeleteFacesParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFaces>>, TError,{data?: FacesToBeDeleted;params?: DeleteFacesParams}, TContext> => {

const mutationKey = ['deleteFaces'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFaces>>, {data?: FacesToBeDeleted;params?: DeleteFacesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteFaces(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFacesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFaces>>>
    export type DeleteFacesMutationBody = FacesToBeDeleted | undefined
    export type DeleteFacesMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete faces
 */
export const useDeleteFaces = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFaces>>, TError,{data?: FacesToBeDeleted;params?: DeleteFacesParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFaces>>,
        TError,
        {data?: FacesToBeDeleted;params?: DeleteFacesParams},
        TContext
      > => {
      return useMutation(getDeleteFacesMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary faces options
 */
export const getFacesOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/faces`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFacesOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFacesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFacesOptions>>, TError,void, TContext> => {

const mutationKey = ['getFacesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFacesOptions>>, void> = () => {


          return  getFacesOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFacesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFacesOptions>>>

    export type GetFacesOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary faces options
 */
export const useGetFacesOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFacesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFacesOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetFacesOptionsMutationOptions(options), queryClient);
    }

/**
 * Update face fields: `card_id`, `user_data`, `avatar`, `event_id`.
 *
 * Linking the face to a card attaches it to all lists of that card and detaches it from the lists
 * of the previous card.
 *
 * **Visibility rules for `/{face_id}`:**
 *
 * - `"global"` — any face in the domain.
 * - `"local"` — only faces linked to cards from lists accessible to the user's departments. Returns 403 otherwise.
 * - `"basic"` — only faces linked to cards from open lists accessible to the user's departments. Returns 403 otherwise.
 *
 * **Visibility rules for `card_id`:**
 *
 * - `"global"` — any card in the domain.
 * - `"local"` — only cards from lists accessible to the user's departments. Returns 403 otherwise.
 * - `"basic"` — only cards from open lists accessible to the user's departments. Returns 403 otherwise.
 *
 * **Owner department rule:** User must be a member of all `owner_department`s of the card's lists.
 * @summary patch face
 */
export const patchFace = (
    faceId: Uuid,
    faceToBeUpdated: FaceToBeUpdated,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/faces/${faceId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: faceToBeUpdated, signal
    },
      options);
    }




export const getPatchFaceMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchFace>>, TError,{faceId: Uuid;data: FaceToBeUpdated}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchFace>>, TError,{faceId: Uuid;data: FaceToBeUpdated}, TContext> => {

const mutationKey = ['patchFace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchFace>>, {faceId: Uuid;data: FaceToBeUpdated}> = (props) => {
          const {faceId,data} = props ?? {};

          return  patchFace(faceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchFaceMutationResult = NonNullable<Awaited<ReturnType<typeof patchFace>>>
    export type PatchFaceMutationBody = FaceToBeUpdated
    export type PatchFaceMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary patch face
 */
export const usePatchFace = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchFace>>, TError,{faceId: Uuid;data: FaceToBeUpdated}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchFace>>,
        TError,
        {faceId: Uuid;data: FaceToBeUpdated},
        TContext
      > => {
      return useMutation(getPatchFaceMutationOptions(options), queryClient);
    }

/**
 * Get face by ID.
 *
 * **Visibility rules for `/{face_id}`:**
 *
 * - `"global"` — any face in the domain.
 * - `"local"` — only faces linked to cards from lists accessible to the user's departments. Returns 403 otherwise.
 * - `"basic"` — only faces linked to cards from open lists accessible to the user's departments. Returns 403 otherwise.
 * @summary get face
 */
export const getFace = (
    faceId: Uuid,
    params?: GetFaceParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<OutputFace>(
      {url: `/1/faces/${faceId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFaceQueryKey = (faceId: Uuid,
    params?: GetFaceParams,) => {
    return [
    `/1/faces/${faceId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFaceQueryOptions = <TData = Awaited<ReturnType<typeof getFace>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(faceId: Uuid,
    params?: GetFaceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFaceQueryKey(faceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFace>>> = ({ signal }) => getFace(faceId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: faceId !== null && faceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFaceQueryResult = NonNullable<Awaited<ReturnType<typeof getFace>>>
export type GetFaceQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetFace<TData = Awaited<ReturnType<typeof getFace>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params: undefined |  GetFaceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFace>>,
          TError,
          Awaited<ReturnType<typeof getFace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFace<TData = Awaited<ReturnType<typeof getFace>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFace>>,
          TError,
          Awaited<ReturnType<typeof getFace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFace<TData = Awaited<ReturnType<typeof getFace>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get face
 */

export function useGetFace<TData = Awaited<ReturnType<typeof getFace>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFace>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFaceQueryOptions(faceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Remove face by ID.
 *
 *   When the face is removed, attributes (descriptors and basic attributes) linked to the face are deleted.
 *   Samples linked to the face are not deleted. If there are a small number of samples for face, then you can use the resources
 *   ["get face attribute samples"](#operation/getFaceAttributesOptions) >
 *   ["remove face/body sample"](operation/deleteSample) > "delete face" (this resource). If you need to delete faces according to some filters and with all samples,
 *   you can use the ["garbage collection task"](operation/createGCTask) with `target = faces` and `remove_samples` flag enabled.
 *
 *   **Visibility rules for `/{face_id}`:**
 *
 *   - `"global"` — any face in the domain.
 *   - `"local"` — only faces linked to cards from lists accessible to the user's departments. Returns 403 otherwise.
 *   - `"basic"` — only faces linked to cards from open lists accessible to the user's departments. Returns 403 otherwise.
 *
 *   **Owner department rule:** User must be a member of all `owner_department`s of the card's lists.
 * @summary remove face
 */
export const deleteFace = (
    faceId: Uuid,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/faces/${faceId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteFaceMutationOptions = <TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFace>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFace>>, TError,{faceId: Uuid}, TContext> => {

const mutationKey = ['deleteFace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFace>>, {faceId: Uuid}> = (props) => {
          const {faceId} = props ?? {};

          return  deleteFace(faceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteFaceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFace>>>

    export type DeleteFaceMutationError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary remove face
 */
export const useDeleteFace = <TError = AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFace>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFace>>,
        TError,
        {faceId: Uuid},
        TContext
      > => {
      return useMutation(getDeleteFaceMutationOptions(options), queryClient);
    }

/**
 * Check if face with `face_id` exists.
 *
 * **Visibility rules for `/{face_id}`:**
 *
 * - `"global"` — any face in the domain.
 * - `"local"` — only faces linked to cards from lists accessible to the user's departments. Returns 403 otherwise.
 * - `"basic"` — only faces linked to cards from open lists accessible to the user's departments. Returns 403 otherwise.
 * @summary check if face exists
 */
export const checkFace = (
    faceId: Uuid,
    params?: CheckFaceParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/faces/${faceId}`, method: 'HEAD',
        params, signal
    },
      options);
    }




export const getCheckFaceMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | InternalServerErrorWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkFace>>, TError,{faceId: Uuid;params?: CheckFaceParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkFace>>, TError,{faceId: Uuid;params?: CheckFaceParams}, TContext> => {

const mutationKey = ['checkFace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkFace>>, {faceId: Uuid;params?: CheckFaceParams}> = (props) => {
          const {faceId,params} = props ?? {};

          return  checkFace(faceId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckFaceMutationResult = NonNullable<Awaited<ReturnType<typeof checkFace>>>

    export type CheckFaceMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | InternalServerErrorWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if face exists
 */
export const useCheckFace = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | InternalServerErrorWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkFace>>, TError,{faceId: Uuid;params?: CheckFaceParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkFace>>,
        TError,
        {faceId: Uuid;params?: CheckFaceParams},
        TContext
      > => {
      return useMutation(getCheckFaceMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary face options
 */
export const getFaceOptions = (
    faceId: Uuid,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/faces/${faceId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFaceOptionsMutationOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFaceOptions>>, TError,{faceId: Uuid}, TContext> => {

const mutationKey = ['getFaceOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFaceOptions>>, {faceId: Uuid}> = (props) => {
          const {faceId} = props ?? {};

          return  getFaceOptions(faceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFaceOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFaceOptions>>>

    export type GetFaceOptionsMutationError = InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary face options
 */
export const useGetFaceOptions = <TError = InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFaceOptions>>,
        TError,
        {faceId: Uuid},
        TContext
      > => {
      return useMutation(getGetFaceOptionsMutationOptions(options), queryClient);
    }

/**
 * Put face attribute.
 *
 * This request changes all the attribute data corresponding to the specified face.
 *
 * The attribute can be specified by temporary attribute ID or using external attribute data (descriptors and/or basic attributes).
 * @summary put face attribute
 */
export const putFaceAttributes = (
    faceId: Uuid,
    putFaceAttributesBody: Attribute | AttributeBinary,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/faces/${faceId}/attributes`, method: 'PUT',
      data: putFaceAttributesBody, signal
    },
      options);
    }




export const getPutFaceAttributesMutationOptions = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFaceAttributes>>, TError,{faceId: Uuid;data: Attribute | AttributeBinary}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putFaceAttributes>>, TError,{faceId: Uuid;data: Attribute | AttributeBinary}, TContext> => {

const mutationKey = ['putFaceAttributes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putFaceAttributes>>, {faceId: Uuid;data: Attribute | AttributeBinary}> = (props) => {
          const {faceId,data} = props ?? {};

          return  putFaceAttributes(faceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutFaceAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof putFaceAttributes>>>
    export type PutFaceAttributesMutationBody = Attribute | AttributeBinary
    export type PutFaceAttributesMutationError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary put face attribute
 */
export const usePutFaceAttributes = <TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFaceAttributes>>, TError,{faceId: Uuid;data: Attribute | AttributeBinary}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putFaceAttributes>>,
        TError,
        {faceId: Uuid;data: Attribute | AttributeBinary},
        TContext
      > => {
      return useMutation(getPutFaceAttributesMutationOptions(options), queryClient);
    }

/**
 * Get face attribute by ID.
 * @summary get face attribute
 */
export const getFaceAttributes = (
    faceId: Uuid,
    params?: GetFaceAttributesParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<OutputFaceAttributeJson | OutputFaceAttributeMsgpack>(
      {url: `/1/faces/${faceId}/attributes`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFaceAttributesQueryKey = (faceId: Uuid,
    params?: GetFaceAttributesParams,) => {
    return [
    `/1/faces/${faceId}/attributes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFaceAttributesQueryOptions = <TData = Awaited<ReturnType<typeof getFaceAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(faceId: Uuid,
    params?: GetFaceAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFaceAttributesQueryKey(faceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFaceAttributes>>> = ({ signal }) => getFaceAttributes(faceId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: faceId !== null && faceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFaceAttributesQueryResult = NonNullable<Awaited<ReturnType<typeof getFaceAttributes>>>
export type GetFaceAttributesQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFaceAttributes<TData = Awaited<ReturnType<typeof getFaceAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params: undefined |  GetFaceAttributesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceAttributes>>,
          TError,
          Awaited<ReturnType<typeof getFaceAttributes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceAttributes<TData = Awaited<ReturnType<typeof getFaceAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceAttributes>>,
          TError,
          Awaited<ReturnType<typeof getFaceAttributes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceAttributes<TData = Awaited<ReturnType<typeof getFaceAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get face attribute
 */

export function useGetFaceAttributes<TData = Awaited<ReturnType<typeof getFaceAttributes>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid,
    params?: GetFaceAttributesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributes>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFaceAttributesQueryOptions(faceId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary face options
 */
export const getFaceAttributesOptions = (
    faceId: Uuid,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/faces/${faceId}/attributes`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFaceAttributesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesOptions>>, TError,{faceId: Uuid}, TContext> => {

const mutationKey = ['getFaceAttributesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFaceAttributesOptions>>, {faceId: Uuid}> = (props) => {
          const {faceId} = props ?? {};

          return  getFaceAttributesOptions(faceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFaceAttributesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFaceAttributesOptions>>>

    export type GetFaceAttributesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary face options
 */
export const useGetFaceAttributesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFaceAttributesOptions>>,
        TError,
        {faceId: Uuid},
        TContext
      > => {
      return useMutation(getGetFaceAttributesOptionsMutationOptions(options), queryClient);
    }

/**
 * Get face attribute samples by face ID.
 * @summary get face attribute samples
 */
export const getFaceAttributeSamples = (
    faceId: Uuid,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<AttributeSamples>(
      {url: `/1/faces/${faceId}/attributes/samples`, method: 'GET', signal
    },
      options);
    }




export const getGetFaceAttributeSamplesQueryKey = (faceId: Uuid,) => {
    return [
    `/1/faces/${faceId}/attributes/samples`
    ] as const;
    }


export const getGetFaceAttributeSamplesQueryOptions = <TData = Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(faceId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFaceAttributeSamplesQueryKey(faceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFaceAttributeSamples>>> = ({ signal }) => getFaceAttributeSamples(faceId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: faceId !== null && faceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFaceAttributeSamplesQueryResult = NonNullable<Awaited<ReturnType<typeof getFaceAttributeSamples>>>
export type GetFaceAttributeSamplesQueryError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFaceAttributeSamples<TData = Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceAttributeSamples>>,
          TError,
          Awaited<ReturnType<typeof getFaceAttributeSamples>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceAttributeSamples<TData = Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceAttributeSamples>>,
          TError,
          Awaited<ReturnType<typeof getFaceAttributeSamples>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceAttributeSamples<TData = Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get face attribute samples
 */

export function useGetFaceAttributeSamples<TData = Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError = Error | AuthorizationErrorResponse | ForbiddenFacesErrorResponse | FaceNotFoundErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 faceId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceAttributeSamples>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFaceAttributeSamplesQueryOptions(faceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary faces attributes samples options
 */
export const getFaceAttributesSamplesOptions = (
    faceId: Uuid,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/faces/${faceId}/attributes/samples`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFaceAttributesSamplesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>, TError,{faceId: Uuid}, TContext> => {

const mutationKey = ['getFaceAttributesSamplesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>, {faceId: Uuid}> = (props) => {
          const {faceId} = props ?? {};

          return  getFaceAttributesSamplesOptions(faceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFaceAttributesSamplesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>>

    export type GetFaceAttributesSamplesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary faces attributes samples options
 */
export const useGetFaceAttributesSamplesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>, TError,{faceId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFaceAttributesSamplesOptions>>,
        TError,
        {faceId: Uuid},
        TContext
      > => {
      return useMutation(getGetFaceAttributesSamplesOptionsMutationOptions(options), queryClient);
    }

/**
 * Attach cards to the list or detach cards from the list.
 * @summary link or unlink cards to list
 */
export const updateLinker = (
    updateLinkerBody: UpdateLinkerBody,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void | UpdateLinker207>(
      {url: `/1/linker`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateLinkerBody, signal
    },
      options);
    }




export const getUpdateLinkerMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLinker>>, TError,{data: UpdateLinkerBody}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLinker>>, TError,{data: UpdateLinkerBody}, TContext> => {

const mutationKey = ['updateLinker'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLinker>>, {data: UpdateLinkerBody}> = (props) => {
          const {data} = props ?? {};

          return  updateLinker(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateLinker>>, variables: {data: UpdateLinkerBody}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetCardsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateLinkerMutationResult = NonNullable<Awaited<ReturnType<typeof updateLinker>>>
    export type UpdateLinkerMutationBody = UpdateLinkerBody
    export type UpdateLinkerMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary link or unlink cards to list
 */
export const useUpdateLinker = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLinker>>, TError,{data: UpdateLinkerBody}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLinker>>,
        TError,
        {data: UpdateLinkerBody},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateLinkerMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get handlers according to filters.
 *
 * **Visibility rules** (``permissions.visibility``):
 *
 * - ``"global"`` — returns all handlers in the domain.
 * - ``"local"`` / ``"basic"`` — returns only handlers whose ``owner_department_id``
 *   belongs to the user's departments.
 * @summary get handlers
 */
export const getHandlers = (
    params?: GetHandlersParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<HandlersList>(
      {url: `/1/handlers`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetHandlersQueryKey = (params?: GetHandlersParams,) => {
    return [
    `/1/handlers`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHandlersQueryOptions = <TData = Awaited<ReturnType<typeof getHandlers>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetHandlersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHandlersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHandlers>>> = ({ signal }) => getHandlers(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHandlersQueryResult = NonNullable<Awaited<ReturnType<typeof getHandlers>>>
export type GetHandlersQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetHandlers<TData = Awaited<ReturnType<typeof getHandlers>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetHandlersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandlers>>,
          TError,
          Awaited<ReturnType<typeof getHandlers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandlers<TData = Awaited<ReturnType<typeof getHandlers>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandlers>>,
          TError,
          Awaited<ReturnType<typeof getHandlers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandlers<TData = Awaited<ReturnType<typeof getHandlers>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get handlers
 */

export function useGetHandlers<TData = Awaited<ReturnType<typeof getHandlers>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlers>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHandlersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Create a handler.
 *
 * The handler determines the list of rules (policies) for processing of input images.
 * The handler is always static — you specify its policies at creation time.
 *
 * The handler (with its policies) is created in Luna API via a proxied call.
 * Luna Point 2 stores only handler metadata locally (department, author, timestamps).
 *
 * **Visibility rules** (``permissions.visibility``):
 *
 * ``owner_department_id``:
 *
 * - ``"global"`` — any department in the domain.
 * - ``"local"`` / ``"basic"`` — only departments the user belongs to (otherwise 403).
 *
 * ``match_policy.candidates.list_id``:
 *
 * - ``"global"`` — any list in the domain.
 * - ``"local"`` — any list linked to the user's departments.
 * - ``"basic"`` — only open lists (``department_lists.open = true``) linked to the user's departments.
 * @summary create handler
 */
export const createHandler = (
    createHandlerRequest: CreateHandlerRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreatedHandler>(
      {url: `/1/handlers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createHandlerRequest, signal
    },
      options);
    }




export const getCreateHandlerMutationOptions = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHandler>>, TError,{data: CreateHandlerRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createHandler>>, TError,{data: CreateHandlerRequest}, TContext> => {

const mutationKey = ['createHandler'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHandler>>, {data: CreateHandlerRequest}> = (props) => {
          const {data} = props ?? {};

          return  createHandler(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHandlerMutationResult = NonNullable<Awaited<ReturnType<typeof createHandler>>>
    export type CreateHandlerMutationBody = CreateHandlerRequest
    export type CreateHandlerMutationError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary create handler
 */
export const useCreateHandler = <TError = Error | AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHandler>>, TError,{data: CreateHandlerRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createHandler>>,
        TError,
        {data: CreateHandlerRequest},
        TContext
      > => {
      return useMutation(getCreateHandlerMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary get handlers options
 */
export const getHandlersOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/handlers`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetHandlersOptionsMutationOptions = <TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getHandlersOptions>>, TError,void, TContext> => {

const mutationKey = ['getHandlersOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getHandlersOptions>>, void> = () => {


          return  getHandlersOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetHandlersOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getHandlersOptions>>>

    export type GetHandlersOptionsMutationError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary get handlers options
 */
export const useGetHandlersOptions = <TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlersOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getHandlersOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetHandlersOptionsMutationOptions(options), queryClient);
    }

/**
 * Get handlers count according to filters.
 *
 * **Visibility rules** (``permissions.visibility``):
 *
 * - ``"global"`` — counts all handlers in the domain.
 * - ``"local"`` / ``"basic"`` — counts only handlers whose ``owner_department_id``
 *   belongs to the user's departments.
 * @summary get handlers count
 */
export const getHandlersCount = (
    params?: GetHandlersCountParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<HandlersCount>(
      {url: `/1/handlers/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetHandlersCountQueryKey = (params?: GetHandlersCountParams,) => {
    return [
    `/1/handlers/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetHandlersCountQueryOptions = <TData = Awaited<ReturnType<typeof getHandlersCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetHandlersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlersCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHandlersCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHandlersCount>>> = ({ signal }) => getHandlersCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHandlersCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHandlersCountQueryResult = NonNullable<Awaited<ReturnType<typeof getHandlersCount>>>
export type GetHandlersCountQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetHandlersCount<TData = Awaited<ReturnType<typeof getHandlersCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetHandlersCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlersCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandlersCount>>,
          TError,
          Awaited<ReturnType<typeof getHandlersCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandlersCount<TData = Awaited<ReturnType<typeof getHandlersCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlersCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandlersCount>>,
          TError,
          Awaited<ReturnType<typeof getHandlersCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandlersCount<TData = Awaited<ReturnType<typeof getHandlersCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlersCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get handlers count
 */

export function useGetHandlersCount<TData = Awaited<ReturnType<typeof getHandlersCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetHandlersCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandlersCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHandlersCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary get handlers count options
 */
export const getHandlersCountOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/handlers/count`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetHandlersCountOptionsMutationOptions = <TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlersCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getHandlersCountOptions>>, TError,void, TContext> => {

const mutationKey = ['getHandlersCountOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getHandlersCountOptions>>, void> = () => {


          return  getHandlersCountOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetHandlersCountOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getHandlersCountOptions>>>

    export type GetHandlersCountOptionsMutationError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary get handlers count options
 */
export const useGetHandlersCountOptions = <TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlersCountOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getHandlersCountOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetHandlersCountOptionsMutationOptions(options), queryClient);
    }

/**
 * Get handler by handler ID.
 *
 * **Visibility rules** (``permissions.visibility``):
 *
 * - ``"global"`` — any handler in the domain.
 * - ``"local"`` / ``"basic"`` — only handlers whose ``owner_department_id``
 *   belongs to the user's departments (otherwise 403).
 * @summary get handler
 */
export const getHandler = (
    handlerId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<HandlerRecord>(
      {url: `/1/handlers/${handlerId}`, method: 'GET', signal
    },
      options);
    }




export const getGetHandlerQueryKey = (handlerId: string,) => {
    return [
    `/1/handlers/${handlerId}`
    ] as const;
    }


export const getGetHandlerQueryOptions = <TData = Awaited<ReturnType<typeof getHandler>>, TError = AuthorizationErrorResponse | Error | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(handlerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHandlerQueryKey(handlerId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHandler>>> = ({ signal }) => getHandler(handlerId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: handlerId !== null && handlerId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHandlerQueryResult = NonNullable<Awaited<ReturnType<typeof getHandler>>>
export type GetHandlerQueryError = AuthorizationErrorResponse | Error | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetHandler<TData = Awaited<ReturnType<typeof getHandler>>, TError = AuthorizationErrorResponse | Error | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 handlerId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandler>>,
          TError,
          Awaited<ReturnType<typeof getHandler>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandler<TData = Awaited<ReturnType<typeof getHandler>>, TError = AuthorizationErrorResponse | Error | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 handlerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHandler>>,
          TError,
          Awaited<ReturnType<typeof getHandler>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHandler<TData = Awaited<ReturnType<typeof getHandler>>, TError = AuthorizationErrorResponse | Error | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 handlerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get handler
 */

export function useGetHandler<TData = Awaited<ReturnType<typeof getHandler>>, TError = AuthorizationErrorResponse | Error | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 handlerId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHandler>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHandlerQueryOptions(handlerId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check handler existence by handler ID.
 *
 * The method returns `200` if the handler exists and is available for the user.
 * Response body is not returned.
 *
 * **Visibility rules** (``permissions.visibility``):
 *
 * - ``"global"`` — any handler in the domain.
 * - ``"local"`` / ``"basic"`` — only handlers whose ``owner_department_id``
 *   belongs to the user's departments (otherwise 403).
 * @summary check handler existence
 */
export const checkHandlerExists = (
    handlerId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/handlers/${handlerId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckHandlerExistsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkHandlerExists>>, TError,{handlerId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkHandlerExists>>, TError,{handlerId: string}, TContext> => {

const mutationKey = ['checkHandlerExists'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkHandlerExists>>, {handlerId: string}> = (props) => {
          const {handlerId} = props ?? {};

          return  checkHandlerExists(handlerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckHandlerExistsMutationResult = NonNullable<Awaited<ReturnType<typeof checkHandlerExists>>>

    export type CheckHandlerExistsMutationError = void

    /**
 * @summary check handler existence
 */
export const useCheckHandlerExists = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkHandlerExists>>, TError,{handlerId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkHandlerExists>>,
        TError,
        {handlerId: string},
        TContext
      > => {
      return useMutation(getCheckHandlerExistsMutationOptions(options), queryClient);
    }

/**
 * Replace handler policies and update metadata by handler ID.
 *
 * **Visibility rules** (``permissions.visibility``):
 *
 * ``/{handler_id}``:
 *
 * - ``"global"`` — any handler in the domain.
 * - ``"local"`` / ``"basic"`` — only handlers whose ``owner_department_id``
 *   belongs to the user's departments (otherwise 403).
 *
 * ``owner_department_id``:
 *
 * - ``"global"`` — any department in the domain.
 * - ``"local"`` / ``"basic"`` — only departments the user belongs to (otherwise 403).
 *
 * ``match_policy.candidates.list_id``:
 *
 * - ``"global"`` — any list in the domain.
 * - ``"local"`` — any list linked to the user's departments.
 * - ``"basic"`` — only open lists (``department_lists.open = true``) linked to the user's departments.
 * @summary update handler
 */
export const putHandler = (
    handlerId: string,
    createHandlerRequest: CreateHandlerRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/handlers/${handlerId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createHandlerRequest, signal
    },
      options);
    }




export const getPutHandlerMutationOptions = <TError = Error | AuthorizationErrorResponse | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHandler>>, TError,{handlerId: string;data: CreateHandlerRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putHandler>>, TError,{handlerId: string;data: CreateHandlerRequest}, TContext> => {

const mutationKey = ['putHandler'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putHandler>>, {handlerId: string;data: CreateHandlerRequest}> = (props) => {
          const {handlerId,data} = props ?? {};

          return  putHandler(handlerId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutHandlerMutationResult = NonNullable<Awaited<ReturnType<typeof putHandler>>>
    export type PutHandlerMutationBody = CreateHandlerRequest
    export type PutHandlerMutationError = Error | AuthorizationErrorResponse | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary update handler
 */
export const usePutHandler = <TError = Error | AuthorizationErrorResponse | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putHandler>>, TError,{handlerId: string;data: CreateHandlerRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putHandler>>,
        TError,
        {handlerId: string;data: CreateHandlerRequest},
        TContext
      > => {
      return useMutation(getPutHandlerMutationOptions(options), queryClient);
    }

/**
 * Delete handler by handler ID.
 *
 * Removes handler metadata from local DB and deletes the handler from Luna API.
 *
 * **Visibility rules** (``permissions.visibility``):
 *
 * - ``"global"`` — any handler in the domain.
 * - ``"local"`` / ``"basic"`` — only handlers whose ``owner_department_id``
 *   belongs to the user's departments (otherwise 403).
 * @summary delete handler
 */
export const deleteHandler = (
    handlerId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/handlers/${handlerId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteHandlerMutationOptions = <TError = AuthorizationErrorResponse | Error | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHandler>>, TError,{handlerId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteHandler>>, TError,{handlerId: string}, TContext> => {

const mutationKey = ['deleteHandler'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteHandler>>, {handlerId: string}> = (props) => {
          const {handlerId} = props ?? {};

          return  deleteHandler(handlerId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteHandler>>, variables: {handlerId: string}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetHandlersQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetHandlersCountQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteHandlerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteHandler>>>

    export type DeleteHandlerMutationError = AuthorizationErrorResponse | Error | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete handler
 */
export const useDeleteHandler = <TError = AuthorizationErrorResponse | Error | HandlerNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteHandler>>, TError,{handlerId: string}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteHandler>>,
        TError,
        {handlerId: string},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteHandlerMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary get handler options
 */
export const getHandlerOptions = (
    handlerId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/handlers/${handlerId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetHandlerOptionsMutationOptions = <TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlerOptions>>, TError,{handlerId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getHandlerOptions>>, TError,{handlerId: string}, TContext> => {

const mutationKey = ['getHandlerOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getHandlerOptions>>, {handlerId: string}> = (props) => {
          const {handlerId} = props ?? {};

          return  getHandlerOptions(handlerId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetHandlerOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getHandlerOptions>>>

    export type GetHandlerOptionsMutationError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary get handler options
 */
export const useGetHandlerOptions = <TError = AuthorizationErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getHandlerOptions>>, TError,{handlerId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getHandlerOptions>>,
        TError,
        {handlerId: string},
        TContext
      > => {
      return useMutation(getGetHandlerOptionsMutationOptions(options), queryClient);
    }

/**
 * Allows to process an image or a biometric sample using the specified handler and generate an event.
 *
 * The user must pass `permission_tag`. The event visibility is determined by `permission_tag`.
 * The `permission_tag` value must correspond to one of the `permission_tag` values available to the user.
 *
 * If `stream_id` is specified, it is used only as a link between the event and the stream and does not define event visibility.
 *
 * The `permission_tag` value is saved for the event and is used to determine event visibility.
 * @summary generate events
 */
export const generateHandlerEvents = (
    handlerId: string,
    generateHandlerEventsBody: Blob | GenerateHandlerEventsBodyOnenine | string,
    params: GenerateHandlerEventsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<GenerateHandlerEvents201>(
      {url: `/1/handlers/${handlerId}/events`, method: 'POST',
      data: generateHandlerEventsBody,
        params, signal
    },
      options);
    }




export const getGenerateHandlerEventsMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | HandlerNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateHandlerEvents>>, TError,{handlerId: string;data: Blob | GenerateHandlerEventsBodyOnenine | string;params: GenerateHandlerEventsParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof generateHandlerEvents>>, TError,{handlerId: string;data: Blob | GenerateHandlerEventsBodyOnenine | string;params: GenerateHandlerEventsParams}, TContext> => {

const mutationKey = ['generateHandlerEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateHandlerEvents>>, {handlerId: string;data: Blob | GenerateHandlerEventsBodyOnenine | string;params: GenerateHandlerEventsParams}> = (props) => {
          const {handlerId,data,params} = props ?? {};

          return  generateHandlerEvents(handlerId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateHandlerEventsMutationResult = NonNullable<Awaited<ReturnType<typeof generateHandlerEvents>>>
    export type GenerateHandlerEventsMutationBody = Blob | GenerateHandlerEventsBodyOnenine | string
    export type GenerateHandlerEventsMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | HandlerNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary generate events
 */
export const useGenerateHandlerEvents = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | HandlerNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateHandlerEvents>>, TError,{handlerId: string;data: Blob | GenerateHandlerEventsBodyOnenine | string;params: GenerateHandlerEventsParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateHandlerEvents>>,
        TError,
        {handlerId: string;data: Blob | GenerateHandlerEventsBodyOnenine | string;params: GenerateHandlerEventsParams},
        TContext
      > => {
      return useMutation(getGenerateHandlerEventsMutationOptions(options), queryClient);
    }

/**
 * Get lists according to filters.
 *
 * The method supports sorting using `sort_by` and `sort_order`.
 *
 * Visibility is determined by the ``visibility`` field in the user's
 * role permissions:
 *
 * * ``"global"`` — all lists matching filters.
 * * ``"local"`` — only lists linked to the user's departments.
 * * ``"basic"`` — only open lists linked to the user's departments.
 * @summary get lists
 */
export const getLists = (
    params?: GetListsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<ListsList>(
      {url: `/1/lists`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetListsInfiniteQueryKey = (params?: GetListsParams,) => {
    return [
    'infinite', `/1/lists`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetListsQueryKey = (params?: GetListsParams,) => {
    return [
    `/1/lists`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetListsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLists>>, GetListsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetListsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData, QueryKey, GetListsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLists>>, QueryKey, GetListsParams['page']> = ({ signal, pageParam }) => getLists({...params, 'page': pageParam ?? params?.['page']}, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData, QueryKey, GetListsParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLists>>>
export type GetListsInfiniteQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetListsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLists>>, GetListsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetListsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData, QueryKey, GetListsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLists>>,
          TError,
          Awaited<ReturnType<typeof getLists>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLists>>, GetListsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetListsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData, QueryKey, GetListsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLists>>,
          TError,
          Awaited<ReturnType<typeof getLists>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLists>>, GetListsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetListsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData, QueryKey, GetListsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lists
 */

export function useGetListsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLists>>, GetListsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetListsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData, QueryKey, GetListsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetListsQueryOptions = <TData = Awaited<ReturnType<typeof getLists>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLists>>> = ({ signal }) => getLists(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListsQueryResult = NonNullable<Awaited<ReturnType<typeof getLists>>>
export type GetListsQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetLists<TData = Awaited<ReturnType<typeof getLists>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetListsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLists>>,
          TError,
          Awaited<ReturnType<typeof getLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLists<TData = Awaited<ReturnType<typeof getLists>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLists>>,
          TError,
          Awaited<ReturnType<typeof getLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLists<TData = Awaited<ReturnType<typeof getLists>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lists
 */

export function useGetLists<TData = Awaited<ReturnType<typeof getLists>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetListsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLists>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Create a new list.
 *
 * Visibility rules for ``owner_department``:
 *
 * * ``"global"`` — any department in the domain.
 * * ``"local"`` / ``"basic"`` — only departments the user belongs to.
 * @summary create list
 */
export const createList = (
    createListRequest: CreateListRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreatedList>(
      {url: `/1/lists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createListRequest, signal
    },
      options);
    }




export const getCreateListMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createList>>, TError,{data: CreateListRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createList>>, TError,{data: CreateListRequest}, TContext> => {

const mutationKey = ['createList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createList>>, {data: CreateListRequest}> = (props) => {
          const {data} = props ?? {};

          return  createList(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createList>>, variables: {data: CreateListRequest}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetDepartmentQueryKey(variables.departmentId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateListMutationResult = NonNullable<Awaited<ReturnType<typeof createList>>>
    export type CreateListMutationBody = CreateListRequest
    export type CreateListMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary create list
 */
export const useCreateList = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createList>>, TError,{data: CreateListRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createList>>,
        TError,
        {data: CreateListRequest},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateListMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Delete several lists by list IDs.
 *
 * Visibility rules:
 *
 * * ``"global"`` — any lists in the domain.
 * * ``"local"`` — only lists linked to the user's departments.
 * * ``"basic"`` — only open lists linked to the user's departments.
 * @summary delete lists
 */
export const deleteLists = (
    deleteListsRequest: DeleteListsRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/lists`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteListsRequest, signal
    },
      options);
    }




export const getDeleteListsMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLists>>, TError,{data: DeleteListsRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLists>>, TError,{data: DeleteListsRequest}, TContext> => {

const mutationKey = ['deleteLists'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLists>>, {data: DeleteListsRequest}> = (props) => {
          const {data} = props ?? {};

          return  deleteLists(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteListsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLists>>>
    export type DeleteListsMutationBody = DeleteListsRequest
    export type DeleteListsMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete lists
 */
export const useDeleteLists = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLists>>, TError,{data: DeleteListsRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLists>>,
        TError,
        {data: DeleteListsRequest},
        TContext
      > => {
      return useMutation(getDeleteListsMutationOptions(options), queryClient);
    }

/**
 * Get lists count according to filters.
 *
 * Sorting is not used for this method because the method returns aggregated lists count only.
 * @summary get lists count
 */
export const getListsCount = (
    params?: GetListsCountParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<ListsCount>(
      {url: `/1/lists/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetListsCountQueryKey = (params?: GetListsCountParams,) => {
    return [
    `/1/lists/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetListsCountQueryOptions = <TData = Awaited<ReturnType<typeof getListsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(params?: GetListsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListsCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getListsCount>>> = ({ signal }) => getListsCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getListsCount>>>
export type GetListsCountQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetListsCount<TData = Awaited<ReturnType<typeof getListsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetListsCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListsCount>>,
          TError,
          Awaited<ReturnType<typeof getListsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListsCount<TData = Awaited<ReturnType<typeof getListsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetListsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getListsCount>>,
          TError,
          Awaited<ReturnType<typeof getListsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetListsCount<TData = Awaited<ReturnType<typeof getListsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetListsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get lists count
 */

export function useGetListsCount<TData = Awaited<ReturnType<typeof getListsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 params?: GetListsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getListsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListsCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get list by list ID.
 *
 * Visibility rules for ``/{list_id}``:
 *
 * * ``"global"`` — any list in the domain.
 * * ``"local"`` — only lists linked to the user's departments.
 * * ``"basic"`` — only open lists linked to the user's departments.
 * @summary get list
 */
export const getList = (
    listId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<ListRecord>(
      {url: `/1/lists/${listId}`, method: 'GET', signal
    },
      options);
    }




export const getGetListQueryKey = (listId: string,) => {
    return [
    `/1/lists/${listId}`
    ] as const;
    }


export const getGetListQueryOptions = <TData = Awaited<ReturnType<typeof getList>>, TError = AuthorizationErrorResponse | Error | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(listId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetListQueryKey(listId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getList>>> = ({ signal }) => getList(listId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: listId !== null && listId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetListQueryResult = NonNullable<Awaited<ReturnType<typeof getList>>>
export type GetListQueryError = AuthorizationErrorResponse | Error | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse


export function useGetList<TData = Awaited<ReturnType<typeof getList>>, TError = AuthorizationErrorResponse | Error | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 listId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getList>>,
          TError,
          Awaited<ReturnType<typeof getList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetList<TData = Awaited<ReturnType<typeof getList>>, TError = AuthorizationErrorResponse | Error | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 listId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getList>>,
          TError,
          Awaited<ReturnType<typeof getList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetList<TData = Awaited<ReturnType<typeof getList>>, TError = AuthorizationErrorResponse | Error | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 listId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get list
 */

export function useGetList<TData = Awaited<ReturnType<typeof getList>>, TError = AuthorizationErrorResponse | Error | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse>(
 listId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getList>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetListQueryOptions(listId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check list existence by list ID.
 *
 * The method returns `200` if the list exists and is available for the user.
 * @summary check list existence
 */
export const checkListExists = (
    listId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/lists/${listId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckListExistsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkListExists>>, TError,{listId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkListExists>>, TError,{listId: string}, TContext> => {

const mutationKey = ['checkListExists'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkListExists>>, {listId: string}> = (props) => {
          const {listId} = props ?? {};

          return  checkListExists(listId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckListExistsMutationResult = NonNullable<Awaited<ReturnType<typeof checkListExists>>>

    export type CheckListExistsMutationError = void

    /**
 * @summary check list existence
 */
export const useCheckListExists = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkListExists>>, TError,{listId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkListExists>>,
        TError,
        {listId: string},
        TContext
      > => {
      return useMutation(getCheckListExistsMutationOptions(options), queryClient);
    }

/**
 * Update list parameters by list ID.
 *
 * The method supports updating the following list parameters:
 * - `user_data`;
 * - `is_active`;
 * - `owner_department`.
 *
 * Visibility rules for ``/{list_id}``:
 *
 * * ``"global"`` — any list in the domain.
 * * ``"local"`` — only lists linked to the user's departments.
 * * ``"basic"`` — only open lists linked to the user's departments.
 *
 * Visibility rules for ``owner_department``:
 *
 * * ``"global"`` — any department in the domain.
 * * ``"local"`` / ``"basic"`` — only departments the user belongs to.
 * @summary update list
 */
export const updateList = (
    listId: string,
    updateListRequest: UpdateListRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/lists/${listId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateListRequest, signal
    },
      options);
    }




export const getUpdateListMutationOptions = <TError = Error | AuthorizationErrorResponse | ListNotFoundResponse | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateList>>, TError,{listId: string;data: UpdateListRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateList>>, TError,{listId: string;data: UpdateListRequest}, TContext> => {

const mutationKey = ['updateList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateList>>, {listId: string;data: UpdateListRequest}> = (props) => {
          const {listId,data} = props ?? {};

          return  updateList(listId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateListMutationResult = NonNullable<Awaited<ReturnType<typeof updateList>>>
    export type UpdateListMutationBody = UpdateListRequest
    export type UpdateListMutationError = Error | AuthorizationErrorResponse | ListNotFoundResponse | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary update list
 */
export const useUpdateList = <TError = Error | AuthorizationErrorResponse | ListNotFoundResponse | DepartmentNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateList>>, TError,{listId: string;data: UpdateListRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateList>>,
        TError,
        {listId: string;data: UpdateListRequest},
        TContext
      > => {
      return useMutation(getUpdateListMutationOptions(options), queryClient);
    }

/**
 * Delete list by list ID.
 *
 * Visibility rules:
 *
 * * ``"global"`` — any list in the domain.
 * * ``"local"`` — only lists linked to the user's departments.
 * * ``"basic"`` — only open lists linked to the user's departments.
 * @summary delete list
 */
export const deleteList = (
    listId: string,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/lists/${listId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteListMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteList>>, TError,{listId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteList>>, TError,{listId: string}, TContext> => {

const mutationKey = ['deleteList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteList>>, {listId: string}> = (props) => {
          const {listId} = props ?? {};

          return  deleteList(listId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteListMutationResult = NonNullable<Awaited<ReturnType<typeof deleteList>>>

    export type DeleteListMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete list
 */
export const useDeleteList = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ListNotFoundResponse | InternalServerErrorResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteList>>, TError,{listId: string}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteList>>,
        TError,
        {listId: string},
        TContext
      > => {
      return useMutation(getDeleteListMutationOptions(options), queryClient);
    }

/**
 * Returns a list of events by filters.
 *
 * The result is limited to events whose `permission_tag` corresponds to one of the `permission_tag` values available to the user.
 *
 * If no accessible events match the filters, the method returns 200 with an empty `events` array.
 *
 * If `event_ids`, `event_id__gte`, `event_id__lt`, `create_time__gte` and `create_time__lt` are not specified,
 * the default period is applied: `create_time__lt` equals the current time and `create_time__gte` equals the current time minus one month.
 *
 * The `stream_ids` filter is applied without a separate stream existence check. If no accessible events match the filter, an empty result is returned.
 * @summary get events
 */
export const getEvents = (
    params?: GetEventsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<EventsList>(
      {url: `/1/events`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetEventsInfiniteQueryKey = (params?: GetEventsParams,) => {
    return [
    'infinite', `/1/events`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetEventsQueryKey = (params?: GetEventsParams,) => {
    return [
    `/1/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEventsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getEvents>>, GetEventsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetEventsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>, QueryKey, GetEventsParams['page']> = ({ signal, pageParam }) => getEvents({...params, 'page': pageParam ?? params?.['page']}, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsInfiniteQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetEventsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEvents>>, GetEventsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetEventsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEvents>>, GetEventsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEvents>>, GetEventsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get events
 */

export function useGetEventsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getEvents>>, GetEventsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData, QueryKey, GetEventsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEventsQueryOptions = <TData = Awaited<ReturnType<typeof getEvents>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>> = ({ signal }) => getEvents(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get events
 */

export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Returns event statistics using `targets`, `filters`, `period` and `group_by`.
 *
 * Statistics are calculated only for events whose `permission_tag`
 * corresponds to one of the `permission_tag` values available to the user.
 * @summary get events statistic
 */
export const getEventsStatistic = (
    eventStatisticRequest: EventStatisticRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<EventStatisticResponse>(
      {url: `/1/events/statistic`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eventStatisticRequest, signal
    },
      options);
    }




export const getGetEventsStatisticMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEventsStatistic>>, TError,{data: EventStatisticRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getEventsStatistic>>, TError,{data: EventStatisticRequest}, TContext> => {

const mutationKey = ['getEventsStatistic'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getEventsStatistic>>, {data: EventStatisticRequest}> = (props) => {
          const {data} = props ?? {};

          return  getEventsStatistic(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetEventsStatisticMutationResult = NonNullable<Awaited<ReturnType<typeof getEventsStatistic>>>
    export type GetEventsStatisticMutationBody = EventStatisticRequest
    export type GetEventsStatisticMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary get events statistic
 */
export const useGetEventsStatistic = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getEventsStatistic>>, TError,{data: EventStatisticRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getEventsStatistic>>,
        TError,
        {data: EventStatisticRequest},
        TContext
      > => {
      return useMutation(getGetEventsStatisticMutationOptions(options), queryClient);
    }

/**
 * Returns an event by identifier.
 *
 * The event is available to the user only if the event `permission_tag`
 * corresponds to one of the `permission_tag` values available to the user.
 * @summary get event
 */
export const getEvent = (
    eventId: Uuid & unknown,
    params?: GetEventParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<EventRecord>(
      {url: `/1/events/${eventId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetEventQueryKey = (eventId: Uuid & unknown,
    params?: GetEventParams,) => {
    return [
    `/1/events/${eventId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEventQueryOptions = <TData = Awaited<ReturnType<typeof getEvent>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | EventNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(eventId: Uuid & unknown,
    params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventQueryKey(eventId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvent>>> = ({ signal }) => getEvent(eventId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: eventId !== null && eventId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventQueryResult = NonNullable<Awaited<ReturnType<typeof getEvent>>>
export type GetEventQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | EventNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | EventNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid & unknown,
    params: undefined |  GetEventParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | EventNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid & unknown,
    params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | EventNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid & unknown,
    params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get event
 */

export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | EventNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 eventId: Uuid & unknown,
    params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventQueryOptions(eventId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Checks that an event exists and is available to the user.
 *
 * The event is available to the user only if the event `permission_tag`
 * corresponds to one of the `permission_tag` values available to the user.
 *
 * If the event is not found, the method returns 404. If the event is not available to the user, the method returns 403.
 * @summary check event existence
 */
export const headEvent = (
    eventId: Uuid & unknown,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/events/${eventId}`, method: 'HEAD', signal
    },
      options);
    }




export const getHeadEventMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof headEvent>>, TError,{eventId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof headEvent>>, TError,{eventId: Uuid & unknown}, TContext> => {

const mutationKey = ['headEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof headEvent>>, {eventId: Uuid & unknown}> = (props) => {
          const {eventId} = props ?? {};

          return  headEvent(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HeadEventMutationResult = NonNullable<Awaited<ReturnType<typeof headEvent>>>

    export type HeadEventMutationError = void

    /**
 * @summary check event existence
 */
export const useHeadEvent = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof headEvent>>, TError,{eventId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof headEvent>>,
        TError,
        {eventId: Uuid & unknown},
        TContext
      > => {
      return useMutation(getHeadEventMutationOptions(options), queryClient);
    }

/**
 * Deletes an event by identifier.
 *
 * The event can be deleted only if the event `permission_tag`
 * corresponds to one of the `permission_tag` values available to the user.
 * @summary delete event
 */
export const deleteEvent = (
    eventId: Uuid & unknown,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/events/${eventId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteEventMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | EventNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{eventId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{eventId: Uuid & unknown}, TContext> => {

const mutationKey = ['deleteEvent'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEvent>>, {eventId: Uuid & unknown}> = (props) => {
          const {eventId} = props ?? {};

          return  deleteEvent(eventId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEvent>>>

    export type DeleteEventMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | EventNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete event
 */
export const useDeleteEvent = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | EventNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEvent>>, TError,{eventId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEvent>>,
        TError,
        {eventId: Uuid & unknown},
        TContext
      > => {
      return useMutation(getDeleteEventMutationOptions(options), queryClient);
    }

/**
 * Get groups matching the specified filters.
 *
 * Groups are returned according to their creation order, oldest first.
 * @summary get groups
 */
export const getGroups = (
    params?: GetGroupsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<GroupsList>(
      {url: `/1/groups`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetGroupsInfiniteQueryKey = (params?: GetGroupsParams,) => {
    return [
    'infinite', `/1/groups`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetGroupsQueryKey = (params?: GetGroupsParams,) => {
    return [
    `/1/groups`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGroupsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getGroups>>, GetGroupsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroups>>, QueryKey, GetGroupsParams['page']> = ({ signal, pageParam }) => getGroups({...params, 'page': pageParam ?? params?.['page']}, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getGroups>>>
export type GetGroupsInfiniteQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGroups>>, GetGroupsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetGroupsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroups>>,
          TError,
          Awaited<ReturnType<typeof getGroups>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGroups>>, GetGroupsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroups>>,
          TError,
          Awaited<ReturnType<typeof getGroups>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGroups>>, GetGroupsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get groups
 */

export function useGetGroupsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getGroups>>, GetGroupsParams['page']>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData, QueryKey, GetGroupsParams['page']>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroups>>> = ({ signal }) => getGroups(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getGroups>>>
export type GetGroupsQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroups>>,
          TError,
          Awaited<ReturnType<typeof getGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroups>>,
          TError,
          Awaited<ReturnType<typeof getGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get groups
 */

export function useGetGroups<TData = Awaited<ReturnType<typeof getGroups>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroups>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Create a new stream group.
 * @summary create group
 */
export const createGroup = (
    createGroupRequest: CreateGroupRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreateGroupResponse>(
      {url: `/1/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroupRequest, signal
    },
      options);
    }




export const getCreateGroupMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroupRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroupRequest}, TContext> => {

const mutationKey = ['createGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroup>>, {data: CreateGroupRequest}> = (props) => {
          const {data} = props ?? {};

          return  createGroup(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createGroup>>, variables: {data: CreateGroupRequest}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetGroupsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetGroupsCountQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createGroup>>>
    export type CreateGroupMutationBody = CreateGroupRequest
    export type CreateGroupMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create group
 */
export const useCreateGroup = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroup>>, TError,{data: CreateGroupRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGroup>>,
        TError,
        {data: CreateGroupRequest},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateGroupMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get the number of groups matching the specified filters.
 * @summary get group count
 */
export const getGroupsCount = (
    params?: GetGroupsCountParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<GroupsCount>(
      {url: `/1/groups/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetGroupsCountQueryKey = (params?: GetGroupsCountParams,) => {
    return [
    `/1/groups/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetGroupsCountQueryOptions = <TData = Awaited<ReturnType<typeof getGroupsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetGroupsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupsCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroupsCount>>> = ({ signal }) => getGroupsCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroupsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getGroupsCount>>>
export type GetGroupsCountQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetGroupsCount<TData = Awaited<ReturnType<typeof getGroupsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetGroupsCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupsCount>>,
          TError,
          Awaited<ReturnType<typeof getGroupsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupsCount<TData = Awaited<ReturnType<typeof getGroupsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroupsCount>>,
          TError,
          Awaited<ReturnType<typeof getGroupsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroupsCount<TData = Awaited<ReturnType<typeof getGroupsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get group count
 */

export function useGetGroupsCount<TData = Awaited<ReturnType<typeof getGroupsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetGroupsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroupsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupsCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get a group by its identifier.
 * @summary get group
 */
export const getGroup = (
    groupId: Uuid & unknown,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<GroupRecord>(
      {url: `/1/groups/${groupId}`, method: 'GET', signal
    },
      options);
    }




export const getGetGroupQueryKey = (groupId: Uuid & unknown,) => {
    return [
    `/1/groups/${groupId}`
    ] as const;
    }


export const getGetGroupQueryOptions = <TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(groupId: Uuid & unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGroupQueryKey(groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGroup>>> = ({ signal }) => getGroup(groupId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: groupId !== null && groupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getGroup>>>
export type GetGroupQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 groupId: Uuid & unknown, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroup>>,
          TError,
          Awaited<ReturnType<typeof getGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 groupId: Uuid & unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGroup>>,
          TError,
          Awaited<ReturnType<typeof getGroup>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 groupId: Uuid & unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get group
 */

export function useGetGroup<TData = Awaited<ReturnType<typeof getGroup>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 groupId: Uuid & unknown, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGroup>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGroupQueryOptions(groupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update group fields.
 * @summary update group
 */
export const updateGroup = (
    groupId: Uuid & unknown,
    updateGroupRequest: UpdateGroupRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/groups/${groupId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateGroupRequest, signal
    },
      options);
    }




export const getUpdateGroupMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroup>>, TError,{groupId: Uuid & unknown;data: UpdateGroupRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGroup>>, TError,{groupId: Uuid & unknown;data: UpdateGroupRequest}, TContext> => {

const mutationKey = ['updateGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGroup>>, {groupId: Uuid & unknown;data: UpdateGroupRequest}> = (props) => {
          const {groupId,data} = props ?? {};

          return  updateGroup(groupId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateGroup>>, variables: {groupId: Uuid & unknown;data: UpdateGroupRequest}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetGroupsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetPermissionTagQueryKey(variables.data?.permission_tag) });
    queryClient.invalidateQueries({ queryKey: getGetGroupsCountQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateGroup>>>
    export type UpdateGroupMutationBody = UpdateGroupRequest
    export type UpdateGroupMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary update group
 */
export const useUpdateGroup = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGroup>>, TError,{groupId: Uuid & unknown;data: UpdateGroupRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGroup>>,
        TError,
        {groupId: Uuid & unknown;data: UpdateGroupRequest},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateGroupMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Update an existing stream group by its identifier.
 *
 * The user must have `permissions.group:["update"]`.
 *
 * If the group does not exist, the request returns `404`.
 * If streams_update is set to 1, changes are applied to existing streams associated with the group.
 * @summary update group
 */
export const putGroup = (
    groupId: Uuid & unknown,
    putGroupRequest: PutGroupRequest,
    params?: PutGroupParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<PutGroupResponse>(
      {url: `/1/groups/${groupId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putGroupRequest,
        params, signal
    },
      options);
    }




export const getPutGroupMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGroup>>, TError,{groupId: Uuid & unknown;data: PutGroupRequest;params?: PutGroupParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putGroup>>, TError,{groupId: Uuid & unknown;data: PutGroupRequest;params?: PutGroupParams}, TContext> => {

const mutationKey = ['putGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putGroup>>, {groupId: Uuid & unknown;data: PutGroupRequest;params?: PutGroupParams}> = (props) => {
          const {groupId,data,params} = props ?? {};

          return  putGroup(groupId,data,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof putGroup>>, variables: {groupId: Uuid & unknown;data: PutGroupRequest;params?: PutGroupParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetGroupsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetGroupsCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetGroupQueryKey(variables.groupId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PutGroupMutationResult = NonNullable<Awaited<ReturnType<typeof putGroup>>>
    export type PutGroupMutationBody = PutGroupRequest
    export type PutGroupMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary update group
 */
export const usePutGroup = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGroup>>, TError,{groupId: Uuid & unknown;data: PutGroupRequest;params?: PutGroupParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putGroup>>,
        TError,
        {groupId: Uuid & unknown;data: PutGroupRequest;params?: PutGroupParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPutGroupMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Delete an empty stream group.
 *
 * The user must have `permissions.group:["delete"]`.
 *
 * Only empty groups can be deleted. If the group contains streams, the request returns an error.
 * @summary remove group
 */
export const deleteGroup = (
    groupId: Uuid & unknown,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/groups/${groupId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteGroupMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{groupId: Uuid & unknown}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{groupId: Uuid & unknown}, TContext> => {

const mutationKey = ['deleteGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGroup>>, {groupId: Uuid & unknown}> = (props) => {
          const {groupId} = props ?? {};

          return  deleteGroup(groupId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteGroup>>, variables: {groupId: Uuid & unknown}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetGroupsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetGroupsCountQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGroup>>>

    export type DeleteGroupMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary remove group
 */
export const useDeleteGroup = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroup>>, TError,{groupId: Uuid & unknown}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGroup>>,
        TError,
        {groupId: Uuid & unknown},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteGroupMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Stop or resume stream processing for streams in the group.
 *
 * The action is applied to all streams whose status can be changed.
 * If at least one stream can be changed, the request is completed successfully.
 * Streams that cannot be changed are skipped.
 * If the group has no streams, or if no stream status can be changed, the method returns 200 with `patched_count` equal to 0.
 * @summary patch streams in group
 */
export const patchGroupStreams = (
    groupId: Uuid & unknown,
    params: PatchGroupStreamsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<PatchGroupStreamsResponse>(
      {url: `/1/groups/${groupId}/streams`, method: 'PATCH',
        params, signal
    },
      options);
    }




export const getPatchGroupStreamsMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGroupStreams>>, TError,{groupId: Uuid & unknown;params: PatchGroupStreamsParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchGroupStreams>>, TError,{groupId: Uuid & unknown;params: PatchGroupStreamsParams}, TContext> => {

const mutationKey = ['patchGroupStreams'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchGroupStreams>>, {groupId: Uuid & unknown;params: PatchGroupStreamsParams}> = (props) => {
          const {groupId,params} = props ?? {};

          return  patchGroupStreams(groupId,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof patchGroupStreams>>, variables: {groupId: Uuid & unknown;params: PatchGroupStreamsParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetStreamsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetStreamsCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetGroupsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PatchGroupStreamsMutationResult = NonNullable<Awaited<ReturnType<typeof patchGroupStreams>>>

    export type PatchGroupStreamsMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary patch streams in group
 */
export const usePatchGroupStreams = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGroupStreams>>, TError,{groupId: Uuid & unknown;params: PatchGroupStreamsParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchGroupStreams>>,
        TError,
        {groupId: Uuid & unknown;params: PatchGroupStreamsParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPatchGroupStreamsMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Delete all streams in the group without deleting the group itself.
 *
 * The user must have `permissions.stream:["delete"]`.
 * @summary remove all streams in the group
 */
export const deleteGroupStreams = (
    groupId: Uuid & unknown,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/groups/${groupId}/streams`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteGroupStreamsMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroupStreams>>, TError,{groupId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGroupStreams>>, TError,{groupId: Uuid & unknown}, TContext> => {

const mutationKey = ['deleteGroupStreams'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGroupStreams>>, {groupId: Uuid & unknown}> = (props) => {
          const {groupId} = props ?? {};

          return  deleteGroupStreams(groupId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteGroupStreamsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGroupStreams>>>

    export type DeleteGroupStreamsMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary remove all streams in the group
 */
export const useDeleteGroupStreams = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | GroupNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGroupStreams>>, TError,{groupId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGroupStreams>>,
        TError,
        {groupId: Uuid & unknown},
        TContext
      > => {
      return useMutation(getDeleteGroupStreamsMutationOptions(options), queryClient);
    }

/**
 * Transfer streams to the target group.
 *
 * The user must have `permissions.stream:["update"]`.
 *
 * The request supports two scenarios:
 * - transfer selected streams to the target group;
 * - transfer all streams from selected groups to the target group.
 *
 * Only one of `stream_ids` or `group_ids` must be specified in the request body.
 * @summary transfer streams to group
 */
export const transferGroupStreams = (
    targetGroupId: Uuid & unknown,
    transferGroupStreamsRequest: TransferGroupStreamsRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<TransferGroupStreamsResponse>(
      {url: `/1/groups/${targetGroupId}/streams/transfer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transferGroupStreamsRequest, signal
    },
      options);
    }




export const getTransferGroupStreamsMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferGroupStreams>>, TError,{targetGroupId: Uuid & unknown;data: TransferGroupStreamsRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof transferGroupStreams>>, TError,{targetGroupId: Uuid & unknown;data: TransferGroupStreamsRequest}, TContext> => {

const mutationKey = ['transferGroupStreams'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof transferGroupStreams>>, {targetGroupId: Uuid & unknown;data: TransferGroupStreamsRequest}> = (props) => {
          const {targetGroupId,data} = props ?? {};

          return  transferGroupStreams(targetGroupId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof transferGroupStreams>>, variables: {targetGroupId: Uuid & unknown;data: TransferGroupStreamsRequest}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetStreamsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetStreamsCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetGroupsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type TransferGroupStreamsMutationResult = NonNullable<Awaited<ReturnType<typeof transferGroupStreams>>>
    export type TransferGroupStreamsMutationBody = TransferGroupStreamsRequest
    export type TransferGroupStreamsMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary transfer streams to group
 */
export const useTransferGroupStreams = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof transferGroupStreams>>, TError,{targetGroupId: Uuid & unknown;data: TransferGroupStreamsRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof transferGroupStreams>>,
        TError,
        {targetGroupId: Uuid & unknown;data: TransferGroupStreamsRequest},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getTransferGroupStreamsMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Create a new stream.
 * @summary create stream
 */
export const createStream = (
    createStreamRequest: CreateStreamRequest,
    params?: CreateStreamParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<CreateStreamResponse>(
      {url: `/1/streams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStreamRequest,
        params, signal
    },
      options);
    }




export const getCreateStreamMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStream>>, TError,{data: CreateStreamRequest;params?: CreateStreamParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createStream>>, TError,{data: CreateStreamRequest;params?: CreateStreamParams}, TContext> => {

const mutationKey = ['createStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStream>>, {data: CreateStreamRequest;params?: CreateStreamParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createStream(data,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createStream>>, variables: {data: CreateStreamRequest;params?: CreateStreamParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetStreamsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetStreamsCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetGroupsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateStreamMutationResult = NonNullable<Awaited<ReturnType<typeof createStream>>>
    export type CreateStreamMutationBody = CreateStreamRequest
    export type CreateStreamMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary create stream
 */
export const useCreateStream = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStream>>, TError,{data: CreateStreamRequest;params?: CreateStreamParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createStream>>,
        TError,
        {data: CreateStreamRequest;params?: CreateStreamParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateStreamMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get streams matching the specified filters.
 *
 * Streams are returned according to their creation order.
 * @summary get streams
 */
export const getStreams = (
    params?: GetStreamsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<StreamsList>(
      {url: `/1/streams`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamsQueryKey = (params?: GetStreamsParams,) => {
    return [
    `/1/streams`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamsQueryOptions = <TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreams>>> = ({ signal }) => getStreams(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamsQueryResult = NonNullable<Awaited<ReturnType<typeof getStreams>>>
export type GetStreamsQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetStreamsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreams>>,
          TError,
          Awaited<ReturnType<typeof getStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreams>>,
          TError,
          Awaited<ReturnType<typeof getStreams>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get streams
 */

export function useGetStreams<TData = Awaited<ReturnType<typeof getStreams>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreams>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete streams by identifiers.
 * @summary delete streams
 */
export const deleteStreams = (
    deleteStreamsRequest: DeleteStreamsRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/streams`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteStreamsRequest, signal
    },
      options);
    }




export const getDeleteStreamsMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreams>>, TError,{data: DeleteStreamsRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStreams>>, TError,{data: DeleteStreamsRequest}, TContext> => {

const mutationKey = ['deleteStreams'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStreams>>, {data: DeleteStreamsRequest}> = (props) => {
          const {data} = props ?? {};

          return  deleteStreams(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteStreams>>, variables: {data: DeleteStreamsRequest}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetStreamsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetStreamsCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetGroupsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteStreamsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStreams>>>
    export type DeleteStreamsMutationBody = DeleteStreamsRequest
    export type DeleteStreamsMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete streams
 */
export const useDeleteStreams = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStreams>>, TError,{data: DeleteStreamsRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStreams>>,
        TError,
        {data: DeleteStreamsRequest},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteStreamsMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Count streams matching the specified filters.
 * @summary count streams
 */
export const getStreamsCount = (
    params?: GetStreamsCountParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<StreamsCount>(
      {url: `/1/streams/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamsCountQueryKey = (params?: GetStreamsCountParams,) => {
    return [
    `/1/streams/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamsCountQueryOptions = <TData = Awaited<ReturnType<typeof getStreamsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetStreamsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamsCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamsCount>>> = ({ signal }) => getStreamsCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamsCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamsCountQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamsCount>>>
export type GetStreamsCountQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetStreamsCount<TData = Awaited<ReturnType<typeof getStreamsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetStreamsCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsCount>>,
          TError,
          Awaited<ReturnType<typeof getStreamsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsCount<TData = Awaited<ReturnType<typeof getStreamsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsCount>>,
          TError,
          Awaited<ReturnType<typeof getStreamsCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsCount<TData = Awaited<ReturnType<typeof getStreamsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary count streams
 */

export function useGetStreamsCount<TData = Awaited<ReturnType<typeof getStreamsCount>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsCount>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamsCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get stream logs matching the specified filters.
 *
 * The newest stream logs are returned first.
 * @summary get streams logs
 */
export const getStreamsLogs = (
    params?: GetStreamsLogsParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<StreamsLogs>(
      {url: `/1/streams/logs`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamsLogsQueryKey = (params?: GetStreamsLogsParams,) => {
    return [
    `/1/streams/logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamsLogsQueryOptions = <TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamsLogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamsLogs>>> = ({ signal }) => getStreamsLogs(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamsLogsQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamsLogs>>>
export type GetStreamsLogsQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params: undefined |  GetStreamsLogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsLogs>>,
          TError,
          Awaited<ReturnType<typeof getStreamsLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamsLogs>>,
          TError,
          Awaited<ReturnType<typeof getStreamsLogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get streams logs
 */

export function useGetStreamsLogs<TData = Awaited<ReturnType<typeof getStreamsLogs>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 params?: GetStreamsLogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamsLogs>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamsLogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get data required to access the HLS retransmission of a stream.
 *
 * The JWT token returned in the response must be used to access the HLS stream.
 * @summary get stream retransmission
 */
export const getStreamRestream = (
    streamId: Uuid & unknown,
    params?: GetStreamRestreamParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<StreamRestreamResponse>(
      {url: `/1/streams/${streamId}/restream`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamRestreamQueryKey = (streamId: Uuid & unknown,
    params?: GetStreamRestreamParams,) => {
    return [
    `/1/streams/${streamId}/restream`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamRestreamQueryOptions = <TData = Awaited<ReturnType<typeof getStreamRestream>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(streamId: Uuid & unknown,
    params?: GetStreamRestreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamRestream>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamRestreamQueryKey(streamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreamRestream>>> = ({ signal }) => getStreamRestream(streamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreamRestream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamRestreamQueryResult = NonNullable<Awaited<ReturnType<typeof getStreamRestream>>>
export type GetStreamRestreamQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetStreamRestream<TData = Awaited<ReturnType<typeof getStreamRestream>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: Uuid & unknown,
    params: undefined |  GetStreamRestreamParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamRestream>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamRestream>>,
          TError,
          Awaited<ReturnType<typeof getStreamRestream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamRestream<TData = Awaited<ReturnType<typeof getStreamRestream>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: Uuid & unknown,
    params?: GetStreamRestreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamRestream>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreamRestream>>,
          TError,
          Awaited<ReturnType<typeof getStreamRestream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreamRestream<TData = Awaited<ReturnType<typeof getStreamRestream>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: Uuid & unknown,
    params?: GetStreamRestreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamRestream>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get stream retransmission
 */

export function useGetStreamRestream<TData = Awaited<ReturnType<typeof getStreamRestream>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: Uuid & unknown,
    params?: GetStreamRestreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreamRestream>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamRestreamQueryOptions(streamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check whether a stream with the specified identifier exists.
 * @summary check stream existence
 */
export const headStream = (
    streamId: Uuid & unknown,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/streams/${streamId}`, method: 'HEAD', signal
    },
      options);
    }




export const getHeadStreamMutationOptions = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof headStream>>, TError,{streamId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof headStream>>, TError,{streamId: Uuid & unknown}, TContext> => {

const mutationKey = ['headStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof headStream>>, {streamId: Uuid & unknown}> = (props) => {
          const {streamId} = props ?? {};

          return  headStream(streamId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HeadStreamMutationResult = NonNullable<Awaited<ReturnType<typeof headStream>>>

    export type HeadStreamMutationError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check stream existence
 */
export const useHeadStream = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof headStream>>, TError,{streamId: Uuid & unknown}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof headStream>>,
        TError,
        {streamId: Uuid & unknown},
        TContext
      > => {
      return useMutation(getHeadStreamMutationOptions(options), queryClient);
    }

/**
 * Get a stream by identifier.
 * @summary get stream
 */
export const getStream = (
    streamId: Uuid & unknown,
    params?: GetStreamParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<StreamRecord>(
      {url: `/1/streams/${streamId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetStreamQueryKey = (streamId: Uuid & unknown,
    params?: GetStreamParams,) => {
    return [
    `/1/streams/${streamId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetStreamQueryOptions = <TData = Awaited<ReturnType<typeof getStream>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(streamId: Uuid & unknown,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreamQueryKey(streamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStream>>> = ({ signal }) => getStream(streamId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: streamId !== null && streamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreamQueryResult = NonNullable<Awaited<ReturnType<typeof getStream>>>
export type GetStreamQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: Uuid & unknown,
    params: undefined |  GetStreamParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStream>>,
          TError,
          Awaited<ReturnType<typeof getStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: Uuid & unknown,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStream>>,
          TError,
          Awaited<ReturnType<typeof getStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: Uuid & unknown,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get stream
 */

export function useGetStream<TData = Awaited<ReturnType<typeof getStream>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 streamId: Uuid & unknown,
    params?: GetStreamParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStream>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreamQueryOptions(streamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Fully update a stream by identifier.
 *
 * All fields required for the stream must be provided.
 * @summary update stream
 */
export const updateStream = (
    streamId: Uuid & unknown,
    createStreamRequest: CreateStreamRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<UpdateStreamResponse>(
      {url: `/1/streams/${streamId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: createStreamRequest, signal
    },
      options);
    }




export const getUpdateStreamMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStream>>, TError,{streamId: Uuid & unknown;data: CreateStreamRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateStream>>, TError,{streamId: Uuid & unknown;data: CreateStreamRequest}, TContext> => {

const mutationKey = ['updateStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateStream>>, {streamId: Uuid & unknown;data: CreateStreamRequest}> = (props) => {
          const {streamId,data} = props ?? {};

          return  updateStream(streamId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof updateStream>>, variables: {streamId: Uuid & unknown;data: CreateStreamRequest}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetStreamsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetStreamsCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetGroupsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetStreamQueryKey(variables.streamId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type UpdateStreamMutationResult = NonNullable<Awaited<ReturnType<typeof updateStream>>>
    export type UpdateStreamMutationBody = CreateStreamRequest
    export type UpdateStreamMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary update stream
 */
export const useUpdateStream = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateStream>>, TError,{streamId: Uuid & unknown;data: CreateStreamRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateStream>>,
        TError,
        {streamId: Uuid & unknown;data: CreateStreamRequest},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getUpdateStreamMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Stop or resume a stream by identifier.
 *
 * The operation may not be completed immediately. In this case,
 * `patched_count` is returned as `0` and the request can be repeated later.
 * @summary stop or resume stream
 */
export const patchStream = (
    streamId: Uuid & unknown,
    patchStreamRequest: PatchStreamRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<PatchStreamResponse>(
      {url: `/1/streams/${streamId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchStreamRequest, signal
    },
      options);
    }




export const getPatchStreamMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStream>>, TError,{streamId: Uuid & unknown;data: PatchStreamRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchStream>>, TError,{streamId: Uuid & unknown;data: PatchStreamRequest}, TContext> => {

const mutationKey = ['patchStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchStream>>, {streamId: Uuid & unknown;data: PatchStreamRequest}> = (props) => {
          const {streamId,data} = props ?? {};

          return  patchStream(streamId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof patchStream>>, variables: {streamId: Uuid & unknown;data: PatchStreamRequest}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetStreamsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetStreamsCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetGroupsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PatchStreamMutationResult = NonNullable<Awaited<ReturnType<typeof patchStream>>>
    export type PatchStreamMutationBody = PatchStreamRequest
    export type PatchStreamMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary stop or resume stream
 */
export const usePatchStream = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStream>>, TError,{streamId: Uuid & unknown;data: PatchStreamRequest}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchStream>>,
        TError,
        {streamId: Uuid & unknown;data: PatchStreamRequest},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPatchStreamMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Delete a stream by identifier.
 * @summary delete stream
 */
export const deleteStream = (
    streamId: Uuid & unknown,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/streams/${streamId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteStreamMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStream>>, TError,{streamId: Uuid & unknown}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteStream>>, TError,{streamId: Uuid & unknown}, TContext> => {

const mutationKey = ['deleteStream'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStream>>, {streamId: Uuid & unknown}> = (props) => {
          const {streamId} = props ?? {};

          return  deleteStream(streamId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteStream>>, variables: {streamId: Uuid & unknown}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetStreamsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetStreamsCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetGroupsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteStreamMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStream>>>

    export type DeleteStreamMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary delete stream
 */
export const useDeleteStream = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStream>>, TError,{streamId: Uuid & unknown}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStream>>,
        TError,
        {streamId: Uuid & unknown},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteStreamMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Retrieve available platform features — license status, estimation capabilities, and
 * component availability.
 *
 * The user must be authorized and have the *active* status.
 * @summary get platform features
 */
export const getFeatures = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<FeaturesResponse>(
      {url: `/1/features`, method: 'GET', signal
    },
      options);
    }




export const getGetFeaturesQueryKey = () => {
    return [
    `/1/features`
    ] as const;
    }


export const getGetFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof getFeatures>>, TError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFeaturesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFeatures>>> = ({ signal }) => getFeatures(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getFeatures>>>
export type GetFeaturesQueryError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatures>>,
          TError,
          Awaited<ReturnType<typeof getFeatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFeatures>>,
          TError,
          Awaited<ReturnType<typeof getFeatures>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get platform features
 */

export function useGetFeatures<TData = Awaited<ReturnType<typeof getFeatures>>, TError = AuthorizationErrorResponse | Error | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFeatures>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFeaturesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get options for the resource.
 * @summary features options
 */
export const getFeaturesOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/features`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetFeaturesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFeaturesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getFeaturesOptions>>, TError,void, TContext> => {

const mutationKey = ['getFeaturesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getFeaturesOptions>>, void> = () => {


          return  getFeaturesOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetFeaturesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getFeaturesOptions>>>

    export type GetFeaturesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary features options
 */
export const useGetFeaturesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getFeaturesOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getFeaturesOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetFeaturesOptionsMutationOptions(options), queryClient);
    }

/**
 * Detect faces and/or human bodies and estimate attributes on the input images. After the request is performed, the received data is not saved to the database or Image Store, it is only returned in the response.
 *
 * The order of input images corresponds to the order of the elements in the output JSON.
 *
 * If an input image is corrupted, an error is returned for the image. The processing of the other images continues in normal mode.
 *
 * Notes for incoming data:
 *   - face or body *bounding boxes* passed with face or body warped image will be ignored.
 *
 * The user must be authorized and have the *active* status.
 * @summary estimate image attributes
 */
export const estimateSdk = (
    estimateSdkBody: Blob | MultipartSdkImageSchema | SdkJsonRequestBody,
    params?: EstimateSdkParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<SdkResponseJson | SdkResponseMsgpack>(
      {url: `/1/sdk`, method: 'POST',
      data: estimateSdkBody,
        params, signal
    },
      options);
    }




export const getEstimateSdkMutationOptions = <TError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof estimateSdk>>, TError,{data: Blob | MultipartSdkImageSchema | SdkJsonRequestBody;params?: EstimateSdkParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof estimateSdk>>, TError,{data: Blob | MultipartSdkImageSchema | SdkJsonRequestBody;params?: EstimateSdkParams}, TContext> => {

const mutationKey = ['estimateSdk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof estimateSdk>>, {data: Blob | MultipartSdkImageSchema | SdkJsonRequestBody;params?: EstimateSdkParams}> = (props) => {
          const {data,params} = props ?? {};

          return  estimateSdk(data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EstimateSdkMutationResult = NonNullable<Awaited<ReturnType<typeof estimateSdk>>>
    export type EstimateSdkMutationBody = Blob | MultipartSdkImageSchema | SdkJsonRequestBody
    export type EstimateSdkMutationError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary estimate image attributes
 */
export const useEstimateSdk = <TError = Error | AuthorizationErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof estimateSdk>>, TError,{data: Blob | MultipartSdkImageSchema | SdkJsonRequestBody;params?: EstimateSdkParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof estimateSdk>>,
        TError,
        {data: Blob | MultipartSdkImageSchema | SdkJsonRequestBody;params?: EstimateSdkParams},
        TContext
      > => {
      return useMutation(getEstimateSdkMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary sdk options
 */
export const getSdkOptions = (

 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/sdk`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSdkOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSdkOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSdkOptions>>, TError,void, TContext> => {

const mutationKey = ['getSdkOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSdkOptions>>, void> = () => {


          return  getSdkOptions(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSdkOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSdkOptions>>>

    export type GetSdkOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary sdk options
 */
export const useGetSdkOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSdkOptions>>, TError,void, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSdkOptions>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getGetSdkOptionsMutationOptions(options), queryClient);
    }

/**
 * Match raw descriptor references with raw descriptor candidates.
 *
 * Each reference is matched against every candidate; both are supplied in
 * the request as SDK or raw descriptors, so no stored object is involved
 * and no visibility restrictions apply. References and candidates are
 * identified by client-defined IDs that are echoed back in the response.
 *
 * The request is proxied to Luna API POST /6/matcher/raw.
 * The result is not saved in LUNA POINT and is returned only in the response.
 *
 * Requires an active authenticated user; no additional permission is needed.
 * @summary match raw descriptors
 */
export const matchRaw = (
    matchRawRequest: MatchRawRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<MatchRawResponse>(
      {url: `/1/matcher/raw`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: matchRawRequest, signal
    },
      options);
    }




export const getMatchRawMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRaw>>, TError,{data: MatchRawRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof matchRaw>>, TError,{data: MatchRawRequest}, TContext> => {

const mutationKey = ['matchRaw'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchRaw>>, {data: MatchRawRequest}> = (props) => {
          const {data} = props ?? {};

          return  matchRaw(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchRawMutationResult = NonNullable<Awaited<ReturnType<typeof matchRaw>>>
    export type MatchRawMutationBody = MatchRawRequest
    export type MatchRawMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary match raw descriptors
 */
export const useMatchRaw = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchRaw>>, TError,{data: MatchRawRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof matchRaw>>,
        TError,
        {data: MatchRawRequest},
        TContext
      > => {
      return useMutation(getMatchRawMutationOptions(options), queryClient);
    }

/**
 * Match face references against candidate groups.
 *
 * References can be faces, cards, events, or face descriptors. Candidate
 * groups can contain faces, cards, or events. Each reference is matched
 * against every candidate group independently.
 *
 * Only objects available to the user can be used as references or candidates.
 * A user with `global` visibility can access all objects in the current domain.
 *
 * For other visibility levels, a list is available when it is linked to one
 * of the user's departments. A card is available when it belongs to at least
 * one available list, and a face is available when its card belongs to at
 * least one available list. An event is available when its permission tag is
 * accessible to the user's departments.
 *
 * Request filters only narrow the set of available objects and do not provide
 * access to otherwise unavailable objects. An object named by a reference or
 * by a candidate filter must exist and be available to the user, otherwise
 * the request is refused.
 *
 * Required permissions depend on what the request addresses: `event_fs: read`
 * when events are used as references or candidates, `card: read` when cards or
 * faces are. A request using both needs both. Descriptor references require
 * neither.
 * @summary match faces
 */
export const matchFaces = (
    matchFacesRequest: MatchFacesRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<MatchFacesResponse>(
      {url: `/1/matcher/faces`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: matchFacesRequest, signal
    },
      options);
    }




export const getMatchFacesMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchFaces>>, TError,{data: MatchFacesRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof matchFaces>>, TError,{data: MatchFacesRequest}, TContext> => {

const mutationKey = ['matchFaces'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchFaces>>, {data: MatchFacesRequest}> = (props) => {
          const {data} = props ?? {};

          return  matchFaces(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchFacesMutationResult = NonNullable<Awaited<ReturnType<typeof matchFaces>>>
    export type MatchFacesMutationBody = MatchFacesRequest
    export type MatchFacesMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary match faces
 */
export const useMatchFaces = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchFaces>>, TError,{data: MatchFacesRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof matchFaces>>,
        TError,
        {data: MatchFacesRequest},
        TContext
      > => {
      return useMutation(getMatchFacesMutationOptions(options), queryClient);
    }

/**
 * Match body references against event candidate groups.
 *
 * References can be events or body descriptors. Candidates are events. Each
 * reference is matched against every candidate group independently.
 *
 * Only events available to the user can be used as references or candidates.
 * A user with `global` visibility can access all events in the current domain.
 * For other visibility levels, event availability is determined by permission
 * tags accessible to the user's departments.
 *
 * Request filters only narrow the set of available events and do not provide
 * access to otherwise unavailable events.
 *
 * Candidates are events, so the `event_fs: read` permission is required.
 * @summary match bodies
 */
export const matchBodies = (
    matchBodiesRequest: MatchBodiesRequest,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<MatchBodiesResponse>(
      {url: `/1/matcher/bodies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: matchBodiesRequest, signal
    },
      options);
    }




export const getMatchBodiesMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchBodies>>, TError,{data: MatchBodiesRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof matchBodies>>, TError,{data: MatchBodiesRequest}, TContext> => {

const mutationKey = ['matchBodies'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof matchBodies>>, {data: MatchBodiesRequest}> = (props) => {
          const {data} = props ?? {};

          return  matchBodies(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MatchBodiesMutationResult = NonNullable<Awaited<ReturnType<typeof matchBodies>>>
    export type MatchBodiesMutationBody = MatchBodiesRequest
    export type MatchBodiesMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary match bodies
 */
export const useMatchBodies = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof matchBodies>>, TError,{data: MatchBodiesRequest}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof matchBodies>>,
        TError,
        {data: MatchBodiesRequest},
        TContext
      > => {
      return useMutation(getMatchBodiesMutationOptions(options), queryClient);
    }

/**
 * Receive an origin image by ID.
 * Returns its expiry date in `X-Luna-Expiry-Date` header.
 * @summary get image
 */
export const getImage = (
    imageId: Uuid,
    params?: GetImageParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<Blob>(
      {url: `/1/images/${imageId}`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }




export const getGetImageQueryKey = (imageId: Uuid,
    params?: GetImageParams,) => {
    return [
    `/1/images/${imageId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetImageQueryOptions = <TData = Awaited<ReturnType<typeof getImage>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(imageId: Uuid,
    params?: GetImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImageQueryKey(imageId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImage>>> = ({ signal }) => getImage(imageId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: imageId !== null && imageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetImageQueryResult = NonNullable<Awaited<ReturnType<typeof getImage>>>
export type GetImageQueryError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetImage<TData = Awaited<ReturnType<typeof getImage>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 imageId: Uuid,
    params: undefined |  GetImageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImage>>,
          TError,
          Awaited<ReturnType<typeof getImage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImage<TData = Awaited<ReturnType<typeof getImage>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 imageId: Uuid,
    params?: GetImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImage>>,
          TError,
          Awaited<ReturnType<typeof getImage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImage<TData = Awaited<ReturnType<typeof getImage>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 imageId: Uuid,
    params?: GetImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get image
 */

export function useGetImage<TData = Awaited<ReturnType<typeof getImage>>, TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | ImageNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 imageId: Uuid,
    params?: GetImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImage>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetImageQueryOptions(imageId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check if image with the given ID exists.
 * Returns its expiry date in `X-Luna-Expiry-Date` header.
 *
 * The request is proxied to Luna API HEAD /6/images/{image_id}.
 * @summary check if image exists
 */
export const checkImage = (
    imageId: Uuid,
    params?: CheckImageParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/images/${imageId}`, method: 'HEAD',
        params, signal
    },
      options);
    }




export const getCheckImageMutationOptions = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkImage>>, TError,{imageId: Uuid;params?: CheckImageParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkImage>>, TError,{imageId: Uuid;params?: CheckImageParams}, TContext> => {

const mutationKey = ['checkImage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkImage>>, {imageId: Uuid;params?: CheckImageParams}> = (props) => {
          const {imageId,params} = props ?? {};

          return  checkImage(imageId,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckImageMutationResult = NonNullable<Awaited<ReturnType<typeof checkImage>>>

    export type CheckImageMutationError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if image exists
 */
export const useCheckImage = <TError = void | AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkImage>>, TError,{imageId: Uuid;params?: CheckImageParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkImage>>,
        TError,
        {imageId: Uuid;params?: CheckImageParams},
        TContext
      > => {
      return useMutation(getCheckImageMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary image options
 */
export const getImageOptions = (
    imageId: Uuid,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/images/${imageId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetImageOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getImageOptions>>, TError,{imageId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getImageOptions>>, TError,{imageId: Uuid}, TContext> => {

const mutationKey = ['getImageOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getImageOptions>>, {imageId: Uuid}> = (props) => {
          const {imageId} = props ?? {};

          return  getImageOptions(imageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetImageOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getImageOptions>>>

    export type GetImageOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary image options
 */
export const useGetImageOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getImageOptions>>, TError,{imageId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getImageOptions>>,
        TError,
        {imageId: Uuid},
        TContext
      > => {
      return useMutation(getGetImageOptionsMutationOptions(options), queryClient);
    }

/**
 * Save face or body sample to the storage.
 * @summary save face/body sample
 */
export const saveSample = (
    sampleType: 'faces' | 'bodies',
    saveSampleBody: Blob,
    params?: SaveSampleParams,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<SampleCreated>(
      {url: `/1/samples/${sampleType}`, method: 'POST',
      headers: {'Content-Type': 'image/jpeg', },
      data: saveSampleBody,
        params, signal
    },
      options);
    }




export const getSaveSampleMutationOptions = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSample>>, TError,{sampleType: 'faces' | 'bodies';data: Blob;params?: SaveSampleParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof saveSample>>, TError,{sampleType: 'faces' | 'bodies';data: Blob;params?: SaveSampleParams}, TContext> => {

const mutationKey = ['saveSample'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveSample>>, {sampleType: 'faces' | 'bodies';data: Blob;params?: SaveSampleParams}> = (props) => {
          const {sampleType,data,params} = props ?? {};

          return  saveSample(sampleType,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveSampleMutationResult = NonNullable<Awaited<ReturnType<typeof saveSample>>>
    export type SaveSampleMutationBody = Blob
    export type SaveSampleMutationError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary save face/body sample
 */
export const useSaveSample = <TError = Error | AuthorizationErrorResponse | PermissionErrorResponse | RequestTimeoutResponse | PayloadToLargeResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveSample>>, TError,{sampleType: 'faces' | 'bodies';data: Blob;params?: SaveSampleParams}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveSample>>,
        TError,
        {sampleType: 'faces' | 'bodies';data: Blob;params?: SaveSampleParams},
        TContext
      > => {
      return useMutation(getSaveSampleMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary samples options
 */
export const getSamplesOptions = (
    sampleType: 'faces' | 'bodies',
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/samples/${sampleType}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSamplesOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSamplesOptions>>, TError,{sampleType: 'faces' | 'bodies'}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSamplesOptions>>, TError,{sampleType: 'faces' | 'bodies'}, TContext> => {

const mutationKey = ['getSamplesOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSamplesOptions>>, {sampleType: 'faces' | 'bodies'}> = (props) => {
          const {sampleType} = props ?? {};

          return  getSamplesOptions(sampleType,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSamplesOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSamplesOptions>>>

    export type GetSamplesOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary samples options
 */
export const useGetSamplesOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSamplesOptions>>, TError,{sampleType: 'faces' | 'bodies'}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSamplesOptions>>,
        TError,
        {sampleType: 'faces' | 'bodies'},
        TContext
      > => {
      return useMutation(getGetSamplesOptionsMutationOptions(options), queryClient);
    }

/**
 * Get face or body sample image by ID.
 * Returns its expiry date in `X-Luna-Expiry-Date` header.
 * @summary get face/body sample
 */
export const getSample = (
    sampleType: 'faces' | 'bodies',
    sampleId: Uuid,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<Blob>(
      {url: `/1/samples/${sampleType}/${sampleId}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }




export const getGetSampleQueryKey = (sampleType: 'faces' | 'bodies',
    sampleId: Uuid,) => {
    return [
    `/1/samples/${sampleType}/${sampleId}`
    ] as const;
    }


export const getGetSampleQueryOptions = <TData = Awaited<ReturnType<typeof getSample>>, TError = AuthorizationErrorResponse | PermissionErrorResponse | SampleNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(sampleType: 'faces' | 'bodies',
    sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSampleQueryKey(sampleType,sampleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSample>>> = ({ signal }) => getSample(sampleType,sampleId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: sampleType !== null && sampleType !== undefined && sampleId !== null && sampleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSampleQueryResult = NonNullable<Awaited<ReturnType<typeof getSample>>>
export type GetSampleQueryError = AuthorizationErrorResponse | PermissionErrorResponse | SampleNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse


export function useGetSample<TData = Awaited<ReturnType<typeof getSample>>, TError = AuthorizationErrorResponse | PermissionErrorResponse | SampleNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleType: 'faces' | 'bodies',
    sampleId: Uuid, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSample>>,
          TError,
          Awaited<ReturnType<typeof getSample>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSample<TData = Awaited<ReturnType<typeof getSample>>, TError = AuthorizationErrorResponse | PermissionErrorResponse | SampleNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleType: 'faces' | 'bodies',
    sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSample>>,
          TError,
          Awaited<ReturnType<typeof getSample>>
        > , 'initialData'
      >, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSample<TData = Awaited<ReturnType<typeof getSample>>, TError = AuthorizationErrorResponse | PermissionErrorResponse | SampleNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleType: 'faces' | 'bodies',
    sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get face/body sample
 */

export function useGetSample<TData = Awaited<ReturnType<typeof getSample>>, TError = AuthorizationErrorResponse | PermissionErrorResponse | SampleNotFoundResponse | RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse>(
 sampleType: 'faces' | 'bodies',
    sampleId: Uuid, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSample>>, TError, TData>>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSampleQueryOptions(sampleType,sampleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check if face or body sample with the given ID exists.
 * Returns its expiry date in `X-Luna-Expiry-Date` header.
 *
 * The request is proxied to Luna API HEAD /6/samples/{sample_type}/{sample_id}.
 * @summary check if face/body sample exists
 */
export const checkSample = (
    sampleType: 'faces' | 'bodies',
    sampleId: Uuid,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/samples/${sampleType}/${sampleId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckSampleMutationOptions = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSample>>, TError,{sampleType: 'faces' | 'bodies';sampleId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkSample>>, TError,{sampleType: 'faces' | 'bodies';sampleId: Uuid}, TContext> => {

const mutationKey = ['checkSample'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkSample>>, {sampleType: 'faces' | 'bodies';sampleId: Uuid}> = (props) => {
          const {sampleType,sampleId} = props ?? {};

          return  checkSample(sampleType,sampleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckSampleMutationResult = NonNullable<Awaited<ReturnType<typeof checkSample>>>

    export type CheckSampleMutationError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse

    /**
 * @summary check if face/body sample exists
 */
export const useCheckSample = <TError = AuthorizationErrorWithoutBodyResponse | ForbiddenErrorWithoutBodyResponse | void | RequestTimeoutWithoutBodyResponse | InternalServerErrorWithoutBodyResponse | ResponseTimeoutWithoutBodyResponse | ServerTimeoutErrorWithoutBodyResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkSample>>, TError,{sampleType: 'faces' | 'bodies';sampleId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkSample>>,
        TError,
        {sampleType: 'faces' | 'bodies';sampleId: Uuid},
        TContext
      > => {
      return useMutation(getCheckSampleMutationOptions(options), queryClient);
    }

/**
 * Get options for the resource.
 * @summary sample options
 */
export const getSampleOptions = (
    sampleType: 'faces' | 'bodies',
    sampleId: Uuid,
 options?: SecondParameter<typeof point2AxiosClient>,signal?: AbortSignal
) => {


      return point2AxiosClient<void>(
      {url: `/1/samples/${sampleType}/${sampleId}`, method: 'OPTIONS', signal
    },
      options);
    }




export const getGetSampleOptionsMutationOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSampleOptions>>, TError,{sampleType: 'faces' | 'bodies';sampleId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof getSampleOptions>>, TError,{sampleType: 'faces' | 'bodies';sampleId: Uuid}, TContext> => {

const mutationKey = ['getSampleOptions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getSampleOptions>>, {sampleType: 'faces' | 'bodies';sampleId: Uuid}> = (props) => {
          const {sampleType,sampleId} = props ?? {};

          return  getSampleOptions(sampleType,sampleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetSampleOptionsMutationResult = NonNullable<Awaited<ReturnType<typeof getSampleOptions>>>

    export type GetSampleOptionsMutationError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse

    /**
 * @summary sample options
 */
export const useGetSampleOptions = <TError = RequestTimeoutResponse | InternalServerErrorResponse | ResponseTimeoutResponse | ServerTimeoutErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getSampleOptions>>, TError,{sampleType: 'faces' | 'bodies';sampleId: Uuid}, TContext>, request?: SecondParameter<typeof point2AxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getSampleOptions>>,
        TError,
        {sampleType: 'faces' | 'bodies';sampleId: Uuid},
        TContext
      > => {
      return useMutation(getGetSampleOptionsMutationOptions(options), queryClient);
    }

